/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { v4 as uuidv4 } from 'uuid'
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Avatar, Box, Button, CircularProgress, CircularProgressLabel, Container, Divider, Flex, FormControl, FormLabel, Grid, HStack, Image, Img, Menu, MenuButton, MenuList, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text, Textarea, useToast } from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import { BsGraphUp } from 'react-icons/bs'
import { FaArrowLeft, FaArrowRight, FaBrain, FaCalendar, FaCheckCircle, FaClock, FaDownload, FaEye, FaEyeSlash, FaFrown, FaHeart, FaMedal, FaPauseCircle, FaPencilAlt, FaPlus, FaRegCheckCircle, FaRegPlayCircle, FaRegStopCircle, FaRegTimesCircle, FaSave, FaSpinner, FaTools, FaUndo } from 'react-icons/fa'
import { FiMail } from 'react-icons/fi'
import { useNavigate, useParams } from 'react-router-dom'
import { AccordionContainer } from '../../../components/AccordionContainer'
import { ButtonCmp } from '../../../components/ButtonCmp'
import LoadingContainer from '../../../components/LoadingContainer'
import { ModalDelete } from '../../../components/ModalDelete'
import { SwitchCmp } from '../../../components/SwitchCmp'
import { iAvaliacaoDashResponse, iAvaliacaoNineBox, iAvaliador, iCardAgendamento, iCompetenciaPDI, iFormPreenchimentoQuestaoResponse, iFormularioDashResponse, iHistoricoRespostaIndividual, iMinhaResposta, iNomeId, iPostAvaliador, iPostNineBox, iProcessoOnboard, iReuniaoOneDashResponse, iUltimoPDIDashResponse, iComentariosFeedback, iCalibracao, iCalibrarNineBoxFeedback, iPDIInfos, iItensATrabalhar, iCalibracaoFeedback, iNineBox, iPontosPositivosNegativos } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { parseJwt } from '../../../services/token'
import { FormatarMensagemEditorDeTexto, GroupBy, PropInvalida, UpdateElementByPosition, useQuery } from '../../../Utils/Helper'
import { Emoji } from '../../PDI/Avaliacao/Components/Emoji'
import { CardAssociado } from './components/CardAssociado'
import { ModalAddParticipante } from './components/ModalAddParticipante'
import { ModalReabrir } from './components/ModalReabrir'
import { RadarChartJs } from './components/RadarChart'
import { Recomendacao } from './components/Recomendacao'
import { SidebarFeedback } from './components/Sidebar'
import { Tabela } from './components/Tabela'
import { TabelaIndicativa } from './components/TabelaIndicativa'
import { CardPDI, GridContainer, HeaderSection, PDIText, SectionAssociados, SectionBody, SectionOnboard, Subtitulo, Titulo } from './styles'
import IconeLove from '../../../assets/IconeLove.svg'
import IconeMagoado from '../../../assets/IconeMagoado.svg'
import IconeFeliz from '../../../assets/IconeFeliz.svg'
import IconePiscada from '../../../assets/IconePiscada.svg'
import IconeTriste from '../../../assets/IconeTriste.svg'
import { iAvaliacoes, iPDI, iPDIAcao, iPostAcao, iPostPDI } from '../../PDI/Criar'
import { TbTargetArrow } from 'react-icons/tb'
import { NineBox } from './components/NineBox'
import { TabelaReunioes } from './components/TabelaReunioes'
import { CardOnboard } from './components/CardOnboard'
import { numberFormatter } from '../../AssessmentPI/Dashboard'
import { MultiplaEscolha } from './components/MultiplaEscolha'
import { CaixaDeSelecao } from './components/CaixaDeSelecao'
import { Discursiva } from './components/Discursiva'
import { Escala } from './components/Escala'
import { ImgSah } from '../../../components/ImgSah'
import { iRealizarReuniaoOne, RealizarReuniaoOne } from './components/RealizarReuniaoOne'
import { QuestaoAlternativa } from './components/Alternativa'
import { QuestaoCaixaSelecao } from './components/CaixaSelecao'
import { QuestaoComentario } from './components/Comentario'
import { CaixaDeSelecaoPreenchimento } from './components/PreenchimentoFormulario/CaixaDeSelecao'
import { DiscursivaPreenchimento } from './components/PreenchimentoFormulario/Discursiva'
import { EscalaPreenchimento } from './components/PreenchimentoFormulario/Escala'
import { MultiplaEscolhaPreenchimento } from './components/PreenchimentoFormulario/MultiplaEscolha'
import { TextAreaCmp } from '../../../components/TextareaCmp'
import { AcaoCard } from './components/Acao'
import { IndicadorChart } from './components/IndicadorChart'
import { TabelaIndicador } from './components/TabelaIndicador'
import { iNota } from '../../Desempenho/NineBox/UsuarioEixo'
import { NineBoxCalibrar } from './components/NineBoxCalibrar'
import { TabelaCalibracao } from './components/TabelaCalibracao'
import { AcaoPDI } from './components/AcaoEdit'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import { iAcao } from '../../RH/VisualizarTrilhaColaborador/Components/TabPDI'
import { Acao } from '../../RH/VisualizarTrilhaColaborador/Components/Acao'
import { CardAcao } from '../../RH/VisualizarTrilhaColaborador/Components/CardAcao'
import { TabelaItensAMelhorar } from './components/TabelaItensAMelhorar'
import { ItemATrabalhar } from './components/ItemATrabalhar'
import { StyledMenuItem } from '../../../components/NavBar/Components/StyledMenuItem'
import { DashBox } from '../../../components/PerfilColaborador/styles'
import { ObterCorQuadrantePorNome } from '../../../components/PerfilColaborador/indesx'
import { ObterImgPorNome } from '../components/NineBox'
import { iAcaoRecomendacao, TabRecomendacao } from './components/Recomendacoes'
import { ModalAcoesRemanejo } from './components/ModalAcoesRemanejo'
import { MdDirections } from 'react-icons/md'

export interface iModel {
  nome: string
  participante: iNomeId
  responsavel: iNomeId
  dashboard: iDashResponse
  entrada: iItemDashResponse[]
  desenvolvimento: iItemDashResponse[]
}

interface iAtualizacaoPDI {
  id: string
  comentario?: string
}

interface iDashResponse {
  itensPendentes?: iItemPendente[]
  resultadoAvaliacoes?: iItensATrabalhar
  pdi?: iPDI
  pontosPositivosNegativos?: iPontosPositivosNegativos
  calibracao?: iCalibracaoFeedback
  competencias?: iCompetenciaPDI[]
  concluido: boolean
  resultadosLiberados?: boolean
  nineBox: iNineBox
  itensConcluidos: boolean
}

export interface iItemPendente {
  mensagem: string
  atrasado: boolean
  titulo: string
  id: string
  url?: string
}

export interface iItemDashResponse {
  id: string
  idExterno?: string
  erroPersonalizado?: string
  acoesParaAprovar?: iAcao[]
  status: number
  ordem: number
  tipo: number
  avaliacaoCalibracaoId?: string
  processar: boolean
  avaliacao?: iAvaliacaoDashResponse
  historicoAvaliacoes?: iAvaliacaoDashResponse[]
  reuniaoOne?: iReuniaoOneDashResponse
  ultimasReunioes?: iReuniaoOneDashResponse[]
  ultimoPDI?: iUltimoPDIDashResponse
  ultimaAvaliacaoNineBox?: iAvaliacaoNineBox
  nineBox?: iPostNineBox
  processosRealizados?: iProcessoOnboard[]
  resultadosIndividuais?: iHistoricoRespostaIndividual[]
  realizarReuniaoOne?: iRealizarReuniaoOne
  agendamento?: iCardAgendamento
  formulario?: iFormularioDashResponse
  itensATrabalhar?: iItensATrabalhar
  comentarios?: iComentariosFeedback[]
  calibracao?: iCalibracao
  feedbackAnterior?: iDashResponse
  calibrarNineBox?: iCalibrarNineBoxFeedback
  pdi?: iPDI
  iniciarAntes?: string
  calibracaoDisponivel?: boolean
  resultadoLiberado?: boolean
  infosPDI?: iPDIInfos
}

interface iTemp {
  avaliacaoId: string
  itemId: string
  avaliador?: iAvaliador
}

interface iEncerrarAval {
  avalId: string
  pesquisaId: string
  itemId: string
}

interface iItemDataFimUpdate {
  itemId: string
  dataFim: string
}

interface iTabGrafico {
  avalId: string
  tab: number
}

interface iModoEdicao {
  pesquisaId: string
  ativo: boolean
}

interface iCalibracaoSelecionada {
  id: string
  avaliacaoId: string
}

interface iPeriodoSelecionado {
  id: string
  val: number
}

interface iAcoesRemanejoInput {
  acaoId: string
  id: string
  novaAcaoId: string
}

export const DashboardIndividualFeedbackPersonalizado: React.FC = () => {
  const nav = useNavigate()
  const toast = useToast()
  const query = useQuery()
  const [ItensOpacosIds, setItensOpacosIds] = useState<string[]>([])
  const [SelecionarNovamente, setSelecionarNovamente] = useState<string[]>([])
  const [ModoEdicao, setModoEdicao] = useState<iModoEdicao[]>([])
  const [CalibracaoEmAndamento, setCalibracaoEmAndamento] = useState<iCalibracaoSelecionada[]>([])
  const [ComentarioItem, setComentarioItem] = useState<Array<{ id: string, texto: string }>>([])
  const [FaseAtual, setFaseAtual] = useState(-1)
  const [Competencias, setCompetencias] = useState<iNomeId[]>([])
  const [ItemAtual, setItemAtual] = useState('')
  const { id, participanteId } = useParams()
  const [IsExpanded, setIsExpanded] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)
  const [IsLoadingRecomendacoes, setIsLoadingRecomendacoes] = useState(false)
  const [IsLoadingItem, setIsLoadingItem] = useState(false)
  const [ModalDeleteAcaoIsOpen, setModalDeleteAcaoIsOpen] = useState(false)
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [AcaoId, setAcaoId] = useState<{ id: string, itemId: string }>()
  const [ModalEncerrarIsOpen, setModalEncerrarIsOpen] = useState(false)
  const [DataFimUpdate, setDataFimUpdate] = useState<iItemDataFimUpdate>()
  const [Model, setModel] = useState<iModel>()
  const [IsLoadingIndividual, setIsLoadingIndividual] = useState(false)
  const [IsLoadingAcao, setIsLoadingAcao] = useState(false)
  const [ModalAcoesIsOpen, setModalAcoesIsOpen] = useState(false)
  const [ItemIdGerarRecomendacoes, setItemIdGerarRecomendacoes] = useState<string>()
  const [Colaborador, setColaborador] = useState<iAvaliador>()
  const [AcaoEdit, setAcaoEdit] = useState<iAcaoRecomendacao>()
  const [EncerrarAval, setEncerrarAval] = useState<iEncerrarAval>()
  const [Tipo, setTipo] = useState<number>()
  const [ModalAddParticipanteIsOpen, setModalAddParticipanteIsOpen] = useState(false)
  const [Temp, setTemp] = useState<iTemp>()
  const [Width, setWidth] = useState(window.innerWidth)
  const [SelectedIndividual, setSelectedIndividual] = useState(1)
  const [TabGrafico, setTabGrafico] = useState<iTabGrafico[]>([])
  const [PeriodoSelecionado, setPeriodoSelecionado] = useState<iPeriodoSelecionado[]>([])
  const [Progressos, setProgressos] = useState<Array<{ acaoId: string, porcentagemProgresso: number, observacaoProgresso?: string }>>([])
  const [ModalIAIsOpen, setModalIAIsOpen] = useState<iItemDashResponse>()
  const [AcoesPDIInput, setAcoesPDIInput] = useState<iAcoesRemanejoInput[]>([])

  const [ModalAcaoIsOpen, setModalAcaoIsOpen] = useState(false)
  const [AcaoAprovarId, setAcaoAprovarId] = useState<string>()
  const [PDIAprovarId, setPDIAprovarId] = useState<string>()

  function onOpenModalDeleteAcao(pdiId: string, acaoId: string): void {
    setModalAcaoIsOpen(true)
    setAcaoAprovarId(acaoId)
    setPDIAprovarId(pdiId)
  }

  function onCloseModalAddParticipante(): void {
    setModalAddParticipanteIsOpen(false)
    setTipo(0)
    setTemp(undefined)
  }

  function onOpenModalDeleteAvaliador(avaliacaoId: string, avaliador: iAvaliador, itemId: string): void {
    setModalAddParticipanteIsOpen(false)
    setModalDeleteIsOpen(true)
    setTemp({
      avaliacaoId: avaliacaoId,
      avaliador: avaliador,
      itemId: itemId
    })
  }

  function IsGestorOrADM(): boolean {
    return parseJwt().adm === 'True' || Model?.responsavel.id === parseJwt().cid
  }

  function onCloseModalDeleteAcao(): void {
    setModalAcaoIsOpen(false)
    setAcaoAprovarId(undefined)
    setPDIAprovarId(undefined)
  }

  function Exluir(itemId: string, pdiId: string, acaoId: string): void {
    appApi.delete(`PDI/${pdiId}/Acao/${acaoId}`)
      .then(() => {
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
      .finally(() => onCloseModalDeleteAcao())
  }

  function ConcluirFeedback(): void {
    appApi.patch(`FeedbackPersonalizado/${id}/Concluir/${participanteId}`)
      .then(() => {
        toast({
          title: 'Feedback concluído com sucesso!',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        getDashboard()
      })
      .catch((err) => console.log(err))
  }

  function CreateAvaliador(form: iPostAvaliador): void {
    form.tipoAvaliador = Tipo ?? 0
    appApi.post(`AvaliacaoPesquisa/${Temp?.avaliacaoId ?? ''}/avaliador`, form)
      .then(() => {
        toast({
          title: 'Avaliador adicionado com sucesso!',
          status: 'success',
          position: 'top',
          duration: 4000
        })
        onGetItemById(Temp?.itemId ?? '')
        onCloseModalAddParticipante()
      })
      .catch(({ response }) => {
        toast({
          title: response.data,
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 3000
        })
      })
  }

  function onOpenModalEditarParticipante(avaliacaoId: string, avaliador: iAvaliador, itemId: string): void {
    setModalAddParticipanteIsOpen(true)
    setTemp({
      avaliacaoId: avaliacaoId,
      avaliador: avaliador,
      itemId: itemId
    })
  }

  function onRequestModalDeleteClose(): void {
    setModalDeleteIsOpen(false)
    setTemp(undefined)
  }

  function ObterCompetencias(): void {
    appApi.get('Competencia/Select')
      .then(res => setCompetencias(res.data))
      .catch(err => console.log(err))
  }

  function onRequestModalEncerrarClose(): void {
    setEncerrarAval(undefined)
    setModalEncerrarIsOpen(false)
  }

  function onOpenModal(tipo: number, itemId: string, avalId: string, colab?: iAvaliador): void {
    setTemp({ avaliacaoId: avalId, itemId: itemId })
    setModalAddParticipanteIsOpen(true)
    setTipo(tipo)
    setColaborador(colab)
  }

  function PrevPage(resLength: number): void {
    if (SelectedIndividual !== 1) {
      setSelectedIndividual(SelectedIndividual - 1)
    } else {
      setSelectedIndividual(resLength)
    }
  }

  function NextPage(resLength: number): void {
    if (SelectedIndividual < (resLength)) {
      setSelectedIndividual(SelectedIndividual + 1)
    } else {
      setSelectedIndividual(1)
    }
  }

  function GetIsSelect(questaoId: string, item: iItemDashResponse): string[] {
    const select: string[] = []
    item.formulario?.resultado?.minhasRespostas?.forEach(e => {
      if (e.questaoId === questaoId) {
        e.alternativasIds?.forEach(altId => {
          select.push(altId)
        })
      }
    })

    console.log(select)
    return select
  }

  function onOpenModalDelete(id: string, itemId: string): void {
    setModalDeleteAcaoIsOpen(true)
    setAcaoId({ id: id, itemId: itemId })
  }

  function onCloseModalDelete(): void {
    setModalDeleteAcaoIsOpen(false)
    setAcaoId(undefined)
  }

  function onUpdateResposta(item: iItemDashResponse, index: number, questaoId?: string, alternativaId?: string, texto?: string, tipo?: number): void {
    if (Model && item.formulario?.resultado) {
      const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
      const copy = item.formulario?.resultado?.minhasRespostas
      if (!copy) return

      if (tipo && tipo === 5 && alternativaId) {
        const index = copy?.findIndex(r => r.questaoId === questaoId && r.alternativasIds?.includes(alternativaId))
        if (index !== -1) {
          copy[index].alternativasIds = copy[index].alternativasIds?.filter(altId => altId !== alternativaId)
        } else {
          const itemIndex = copy?.findIndex(r => r.questaoId === questaoId)
          copy[itemIndex].alternativasIds?.push(alternativaId)
        }
      } else if (alternativaId) {
        const itemIndex = copy?.findIndex(r => r.questaoId === questaoId)
        copy[itemIndex].alternativasIds = [alternativaId]
      } else {
        const itemIndex = copy?.findIndex(r => r.questaoId === questaoId)
        copy[itemIndex].texto = texto
      }
      setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, formulario: { ...item.formulario, resultado: { ...item.formulario?.resultado, minhasRespostas: copy } } }) })
    }
  }

  function onGetItemById(itemId: string, indexcalibracao?: number, gerarRecomendacoes?: boolean): void {
    setIsLoadingItem(true)
    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const index = Model?.[propriedade].findIndex(e => e.id === itemId)
    if (index !== null && index !== undefined && index !== -1 && Model) {
      appApi.get(`FeedbackPersonalizado/${id}/Item/${itemId}?participanteId=${participanteId ?? ''}`)
        .then(res => {
          const data = MarcarIncoerenciaItem(res.data as iItemDashResponse)
          setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, data) })
          if (indexcalibracao) {
            OnRealizarCalibracao(Model[propriedade][indexcalibracao], indexcalibracao)
          }
          if (gerarRecomendacoes) {
            ObterRecomendacaoPorIA(data.itensATrabalhar?.competencias?.map(e => e.competenciaId ?? '') ?? [], data.id, true, data)
          }
        })
        .catch(err => console.log(err))
        .finally(() => setIsLoadingItem(false))
    } else {
      setIsLoadingItem(false)
    }
  }

  function GetParticipantesPendentes(avaliacao: iAvaliacaoDashResponse): any {
    let respondidos = avaliacao.avaliadores.filter(e => e.tipoAvaliador !== 7 && e.respondido).length
    let total = avaliacao.avaliadores.filter(e => e.tipoAvaliador !== 7).length
    if (avaliacao.autoAvaliacao) {
      total++
      if (avaliacao.autoAvaliacao.respondido) respondidos++
    }
    return <Flex gap={'.325rem'} fontSize={'14px'} pr={'.5rem'}>
      Respostas:
      <strong style={{ color: respondidos !== total ? 'var(--Red)' : 'var(--Azul)' }}>{respondidos}/{total}</strong>
    </Flex>
  }

  function onOpenModalEncerrar(avalId: string, pesquisaId: string, itemId: string): void {
    setEncerrarAval({ avalId: avalId, pesquisaId: pesquisaId, itemId: itemId })
    setModalEncerrarIsOpen(true)
  }

  function OnChangeModoEdicao(pesquisaId?: string): void {
    if (!pesquisaId) return

    if (!ModoEdicao.some(e => e.pesquisaId === pesquisaId)) {
      setModoEdicao([...ModoEdicao, { pesquisaId: pesquisaId, ativo: true }])
    } else {
      const objectIndex = ModoEdicao.findIndex(e => e.pesquisaId === pesquisaId)
      const copy = [...ModoEdicao]
      copy[objectIndex].ativo = !copy[objectIndex].ativo
      setModoEdicao(copy)
    }
  }

  function GetColorProgresso(e: number): string {
    const variavel = e
    if (variavel < 25) {
      return 'var(--Red)'
    } else if (variavel < 50) {
      return 'var(--Orange)'
    } else if (variavel < 75) {
      return 'var(--Yellow)'
    } else {
      return 'var(--Green2)'
    }
  }

  function TemColuna(tipo: number, participantes: number[]): boolean {
    return participantes?.includes(tipo) ?? false
  }

  function ReenviarNaoRespondidos(idPesquisa: string): void {
    setIsLoading(true)
    appApi.put(`PesquisaPercepcao/${idPesquisa}/Reenviar?colaboradorId=${Model?.participante.id}`)
      .then(() => {
        toast({
          title: 'Convites reenviados com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right'
        })
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function EncerrarAvaliacao(): void {
    if (EncerrarAval) {
      appApi.patch(`AvaliacaoPesquisa/${EncerrarAval?.avalId}/Encerrar?pesquisaId=${EncerrarAval?.pesquisaId}`)
        .then(() => {
          onGetItemById(EncerrarAval?.itemId ?? '')
          setEncerrarAval(undefined)
          setModalEncerrarIsOpen(false)
        })
        .catch(err => console.log(err))
    }
  }

  function ReabrirAvaliacao(avalId: string, pesquisaId: string, itemId: string): void {
    appApi.patch(`AvaliacaoPesquisa/${avalId}/Reabrir?pesquisaId=${pesquisaId}`)
      .then(() => {
        toast({
          title: 'Avaliação reaberta com sucesso!',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
  }

  function ReenviarConvitesPesquisaInterna(itemId: string, pesquisaId: string): void {
    appApi.patch(`PesquisaInternaConvite/${pesquisaId}/EnviarFeedback?participanteId=${Model?.participante.id}&gestorId=${Model?.responsavel.id ?? ''}&itemFeedbackId=${itemId}&feedbackId=${id}`)
      .then(() => {
        toast({
          title: 'Convites reenviados com sucesso!',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
  }

  function AdiantarItem(itemId: string, indexcalibracao?: number): void {
    setIsLoading(true)
    appApi.patch(`FeedbackPersonalizado/${id}/Participante/${participanteId}/AdiantarItem?itemId=${itemId}`)
      .then(() => {
        toast({
          title: 'Item iniciado com sucesso!',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
        onGetItemById(itemId, indexcalibracao)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function OnSelectItens(selecionados: string[], itemId: string, competenciasLength?: number): void {
    setIsLoading(true)
    appApi.post(`FeedbackPersonalizado/${id}/Participante/${participanteId}/SelecionarItens`, { selecionados: selecionados })
      .then(() => {
        toast({
          title: 'Competências selecionadas com sucesso!',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
        const gerarRecomendacoes = SelecionarNovamente.includes(itemId) || (competenciasLength === 0)
        setSelecionarNovamente([])
        onGetItemById(itemId, undefined, gerarRecomendacoes)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function onChangeCalibracao(itemId: string, calibracao?: iCalibracao): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const indexItem = Model[propriedade].findIndex(e => e.id === itemId)

    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], indexItem, { ...Model[propriedade][indexItem], calibracao: calibracao }) })
  }

  function OnSendCalibracao(itemId: string, avaliacaoId: string, calibracao?: iCalibracao): void {
    if (!calibracao) return

    if (calibracao.questoes.filter(r => !calibracao.respostas.some(e => e.questaoId === r.id)).length > 0) {
      toast({
        title: 'Responda todas as questões para prosseguir!',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })

      return
    }
    setIsLoading(true)
    appApi.post(`RespostaPesquisa/${avaliacaoId}/Consolidar`, {
      respostas: calibracao.respostas
    })
      .then(() => {
        toast({
          title: 'Resposta enviada com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        setCalibracaoEmAndamento([])
        onGetItemById(itemId)
      })
      .catch(err => {
        toast({
          title: 'Erro ao enviar as respostas, tente mais tarde!',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        console.log(err)
      })
      .finally(() => setIsLoading(false))
  }

  function OnRealizarCalibracao(item: iItemDashResponse, index: number): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    setIsLoading(true)
    appApi.get(`RespostaPesquisa/${item.avaliacaoCalibracaoId}/Consolidar`)
      .then((res) => {
        setCalibracaoEmAndamento([{ avaliacaoId: item.avaliacaoCalibracaoId ?? '', id: item.id }])
        setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, calibracao: res.data }) })
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function DeleteAvaliador(): void {
    appApi.delete(`AvaliacaoPesquisa/${Temp?.avaliacaoId ?? ''}/avaliador/${Temp?.avaliador?.id ?? ''}`)
      .then(() => {
        toast({
          title: 'Avaliador removido com sucesso!',
          status: 'success',
          position: 'top',
          duration: 4000
        })
        onGetItemById(Temp?.itemId ?? '')
      })
      .catch(err => console.log(err))
  }

  function SolicitarAjustes(itemId: string, pdiId: string, Acoes: iAcao[]): void {
    const form: iAtualizacaoPDI[] = Acoes.filter(r => r.solicitarAjustes).map((e) => {
      return {
        id: e.id,
        comentario: e.comentario
      }
    })

    appApi.post(`PDI/${pdiId}/Acao/SolicitarAjuste`, form)
      .then(() => {
        const copy = [...Acoes]
        Acoes.forEach(e => {
          if (e.solicitarAjustes) {
            e.status = 2
          }
        })
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
  }

  function AprovarPDI(itemId: string, pdiId: string, Acoes: iAcao[]): void {
    const form: iAtualizacaoPDI[] = Acoes.filter(r => !r.solicitarAjustes).map((e) => {
      return {
        id: e.id,
        comentario: e.comentario
      }
    })
    appApi.post(`PDI/${pdiId}/Acao/Aprovar`, form)
      .then(() => {
        const copy = [...Acoes]
        Acoes.forEach(e => {
          if (!e.solicitarAjustes) {
            e.status = 5
          }
        })
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
  }

  function PrevPagePeriodo(item: iItemDashResponse, Periodo: number): void {
    const indicador = item.calibrarNineBox?.indicador
    if (!indicador) return

    const newValue = Periodo !== 0 ? (Periodo - 1) : (indicador.periodos.length - 1)
    const indexItem = PeriodoSelecionado.findIndex(e => e.id === item.id)
    if (indexItem !== -1) {
      setPeriodoSelecionado(UpdateElementByPosition(PeriodoSelecionado, indexItem, { id: item.id, val: newValue }))
    } else {
      setPeriodoSelecionado([...PeriodoSelecionado, { id: item.id, val: newValue }])
    }
  }

  function NextPagePeriodo(item: iItemDashResponse, Periodo: number): void {
    const indicador = item.calibrarNineBox?.indicador
    if (!indicador) return

    const newValue = (Periodo !== (indicador.periodos.length - 1)) ? (Periodo + 1) : 0
    const indexItem = PeriodoSelecionado.findIndex(e => e.id === item.id)
    if (indexItem !== -1) {
      setPeriodoSelecionado(UpdateElementByPosition(PeriodoSelecionado, indexItem, { id: item.id, val: newValue }))
    } else {
      setPeriodoSelecionado([...PeriodoSelecionado, { id: item.id, val: newValue }])
    }
  }

  function OnSendCalibracaoNineBox(itemId: string, nineBox?: iCalibrarNineBoxFeedback): void {
    if (!nineBox) return

    if (nineBox.notaXInconentente || nineBox.notaYInconentente) {
      toast({
        title: 'Há campos preenchidos com notas inválidas, ajuste as notas e/ou quadrante dessa calibração',
        duration: 4000,
        position: 'top',
        status: 'error'
      })
      return
    }

    const data = {
      colaboradorId: nineBox.colaborador.id,
      boxId: nineBox.nineBox.id,
      notaY: nineBox.notas.notaY,
      notaX: nineBox.notas.notaX,
      quandranteId: nineBox.nomeQuadrante,
      comite: [],
      comentario: nineBox.comentario,
      feedbackId: id
    }

    appApi.post('Colaborador/NineBox', data)
      .then(() => {
        toast({
          title: '9Box calibrado com sucesso!',
          duration: 4000,
          position: 'top',
          status: 'success'
        })
        onGetItemById(itemId)
      })
      .catch((err) => console.log(err))
  }

  function SelecionarQuadrante(itemId: string, id: string, notaX?: number, notaY?: number): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const indexItem = Model[propriedade].findIndex(e => e.id === itemId)
    const item = Model[propriedade][indexItem]
    if (!item.calibrarNineBox) return

    const newItem = { ...item, calibrarNineBox: { ...item.calibrarNineBox, nomeQuadrante: id } }
    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], indexItem, newItem) })
    VerificarIncoerencia(itemId, id, notaX, notaY, newItem)
  }

  function OnChangeComentario(itemId: string, comentario: string): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const indexItem = Model[propriedade].findIndex(e => e.id === itemId)
    const item = Model[propriedade][indexItem]
    if (!item.calibrarNineBox) return

    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], indexItem, { ...item, calibrarNineBox: { ...item.calibrarNineBox, comentario: comentario } }) })
  }

  function AdicionarAcao(acoesInput: iPDIAcao[], itemId: string): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const acoes = [...acoesInput]
    acoes.unshift({
      id: uuidv4(),
      assunto: '',
      colaboradorAcao: false,
      dataFim: '',
      tipo: 0,
      status: 0
    })
    const index = Model[propriedade].findIndex(e => e.id === itemId)
    const item = Model[propriedade][index]
    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, pdi: !item.pdi ? undefined : { ...item.pdi, acoes: acoes } }) })
  }

  function GetPDIId(): string | undefined {
    if (!Model) return
    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const item = Model[propriedade].find(e => e.id === ItemAtual)
    return item?.pdi?.id
  }

  function OnPutAcaoRemanejada(pdis: iPDI[], itemId: string): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const item = Model[propriedade].find(e => e.id === itemId)
    if (!item) return

    const acoes = item.pdi?.acoes ?? []
    const acoesId: iAcoesRemanejoInput[] = []
    pdis.forEach(e => {
      e.acoes.forEach(a => {
        const novoId = uuidv4()
        acoes.unshift({
          id: novoId,
          assunto: a.assunto,
          titulo: a.titulo,
          colaboradorAcao: false,
          dataFim: a.dataFim,
          tipo: a.competenciaId ? 1 : 2,
          status: 0,
          competenciaId: a.competenciaId,
          descricao: a.descricao
        })
        acoesId.push({ id: e.id ?? '', acaoId: a.id, novaAcaoId: novoId })
      })
    })
    const index = Model[propriedade].findIndex(e => e.id === itemId)
    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, pdi: !item.pdi ? undefined : { ...item.pdi, acoes: acoes } }) })
    setAcoesPDIInput(acoesId)
  }

  function GerarAcoesPorRecomendacoes(itemDash: iItemDashResponse): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const acoes: iPDIAcao[] = []
    itemDash.pdi?.acoes.filter(e => !itemDash.itensATrabalhar?.recomendacoes?.some(r => r.competenciaId === e.competenciaId)).forEach(e => {
      acoes.push(e)
    })
    itemDash.itensATrabalhar?.recomendacoes?.forEach(e => {
      acoes.push({
        id: uuidv4(),
        assunto: e.titulo,
        colaboradorAcao: false,
        dataFim: '',
        tipo: e.competenciaId ? 1 : 2,
        status: 0,
        descricao: e.comoFazer,
        titulo: e.oqueFazer,
        competenciaId: e.competenciaId
      })
    })

    const index = Model[propriedade].findIndex(e => e.id === itemDash.id)
    const item = Model[propriedade][index]
    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, pdi: !item.pdi ? undefined : { ...item.pdi, acoes: acoes } }) })
    toast({
      title: 'Ações geradas com sucesso!',
      status: 'success',
      duration: 4000,
      position: 'top'
    })
  }

  function onSaveCompetencia(itemId: string, competencia: iAcaoRecomendacao): void {
    if (!Model) return

    setIsLoadingAcao(true)
    appApi.post(`FeedbackPersonalizado/${id}/IA/${itemId}/Acao`, competencia)
      .then(res => {
        if (res.status === 200) {
          const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
          const index = Model[propriedade].findIndex(e => e.id === itemId)
          const item = Model[propriedade][index]
          const indexComp = Model[propriedade][index].itensATrabalhar?.recomendacoes?.findIndex(e => e.id === competencia.id)
          setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, itensATrabalhar: !item.itensATrabalhar ? undefined : { ...item.itensATrabalhar, recomendacoes: UpdateElementByPosition(item.itensATrabalhar.recomendacoes ?? [], indexComp ?? 0, competencia) } }) })
          toast({
            title: 'Recomendação salva com sucesso!',
            status: 'success',
            duration: 4000,
            position: 'top'
          })
        }
        setAcaoEdit(undefined)
      })
      .catch(err => {
        console.log(err)
        toast({
          title: 'Erro, tente novamente',
          status: 'error',
          duration: 4000,
          position: 'top'
        })
      })
      .finally(() => setIsLoadingAcao(false))
  }

  function onRefreshCompetencia(itemId: string, competenciaId: string): void {
    if (!Model) return

    setIsLoadingAcao(true)
    appApi.post(`FeedbackPersonalizado/${id}/IA/${itemId}/Acao/${competenciaId}`)
      .then(res => {
        if (res.status === 200) {
          setAcaoEdit(res.data)
          toast({
            title: 'Recomendação gerada novamente com sucesso!',
            status: 'success',
            duration: 4000,
            position: 'top'
          })
        }
      })
      .catch(err => {
        console.log(err)
        toast({
          title: 'Erro, tente novamente',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
      })
      .finally(() => setIsLoadingAcao(false))
  }

  function RemoverAcao(id: string, itemId: string): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const index = Model[propriedade].findIndex(e => e.id === itemId)
    const item = Model[propriedade][index]
    console.log(item)
    if (!item.pdi) return

    const copy = [...item.pdi?.acoes?.filter(e => e.id !== id)]
    console.log(copy)
    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, pdi: { ...item.pdi, acoes: copy } }) })
  }

  function PodeRestaurarSugestao(item: iItemDashResponse): boolean {
    const calibrar = item.calibrarNineBox
    if (!calibrar || calibrar.notaDesempenhoSugerida === undefined || calibrar.notaDesempenhoSugerida === null) return false
    if (item.status === 1 || Model?.dashboard.concluido) return false

    return calibrar.notas.notaX !== calibrar.notaDesempenhoSugerida
  }

  function RestaurarNotaSugerida(item: iItemDashResponse): void {
    const calibrar = item.calibrarNineBox
    if (!calibrar || calibrar.notaDesempenhoSugerida === undefined || calibrar.notaDesempenhoSugerida === null) return

    AlterarNota({ notaY: calibrar.notas.notaY, notaX: calibrar.notaDesempenhoSugerida }, item.id)
  }

  function MarcarIncoerenciaItem(item: iItemDashResponse): iItemDashResponse {
    const calibrar = item.calibrarNineBox
    if (!calibrar) return item

    const quadrante = calibrar.nineBox.quadrantes.find(e => e.id === calibrar.nomeQuadrante)
    if (!quadrante) return item

    const configX = calibrar.nineBox.eixosX.find(e => e.id === quadrante.eixoX)
    const configY = calibrar.nineBox.eixosY.find(e => e.id === quadrante.eixoY)
    if (!configX || !configY) return item

    return {
      ...item,
      calibrarNineBox: {
        ...calibrar,
        notaXInconentente: !(calibrar.notas.notaX >= configX.rangeMinimo && calibrar.notas.notaX <= configX.rangeMaximo),
        notaYInconentente: !(calibrar.notas.notaY >= configY.rangeMinimo && calibrar.notas.notaY <= configY.rangeMaximo)
      }
    }
  }

  function VerificarIncoerencia(itemId: string, nome: string, notaX?: number, notaY?: number, newItem?: iItemDashResponse): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const indexItem = Model[propriedade].findIndex(e => e.id === itemId)
    const item = newItem ?? Model[propriedade][indexItem]
    if (!item.calibrarNineBox) return

    item.calibrarNineBox.notaXInconentente = false
    item.calibrarNineBox.notaYInconentente = false
    const quadrante = item.calibrarNineBox.nineBox.quadrantes.find(e => e.id === nome)
    if (quadrante) {
      const configx = item.calibrarNineBox.nineBox.eixosX.find(e => e.id === quadrante.eixoX)
      const configy = item.calibrarNineBox.nineBox.eixosY.find(e => e.id === quadrante.eixoY)
      if (notaX && notaY && configx && configy) {
        if (!(notaX >= configx?.rangeMinimo && notaX <= configx?.rangeMaximo)) {
          item.calibrarNineBox.notaXInconentente = true
        }
        if (!(notaY >= configy?.rangeMinimo && notaY <= configy?.rangeMaximo)) {
          item.calibrarNineBox.notaYInconentente = true
        }
      } else if (configx && configy) {
        if (!(item.calibrarNineBox.notas.notaX >= configx?.rangeMinimo && item.calibrarNineBox.notas.notaX <= configx?.rangeMaximo)) {
          item.calibrarNineBox.notaXInconentente = true
        }
        if (!(item.calibrarNineBox.notas.notaY >= configy?.rangeMinimo && item.calibrarNineBox.notas.notaY <= configy?.rangeMaximo)) {
          item.calibrarNineBox.notaYInconentente = true
        }
      }
    }

    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], indexItem, item) })
  }

  function AlterarNota(notas: iNota, itemId: string): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const indexItem = Model[propriedade].findIndex(e => e.id === itemId)
    const item = Model[propriedade][indexItem]
    if (!item.calibrarNineBox) return

    item.calibrarNineBox.notas = notas
    const configY = item.calibrarNineBox.nineBox.eixosY.find(r => notas.notaY >= r.rangeMinimo && notas.notaY <= r.rangeMaximo)
    const configX = item.calibrarNineBox.nineBox.eixosX.find(r => notas.notaX >= r.rangeMinimo && notas.notaX <= r.rangeMaximo)
    if (configY && configX) {
      const quadrante = item.calibrarNineBox.nineBox.quadrantes.find(r => r.eixoX === configX.id && r.eixoY === configY.id)
      if (quadrante) {
        item.calibrarNineBox.nomeQuadrante = quadrante.id
        if (item.calibrarNineBox.notaXInconentente || item.calibrarNineBox.notaYInconentente) {
          VerificarIncoerencia(itemId, quadrante.id)
        }
      }
    }
    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], indexItem, item) })
  }

  function OnCheckItensATrabalhar(val: boolean, competencia: string, itemId: string): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const indexItem = Model[propriedade].findIndex(e => e.id === itemId)
    const item = Model[propriedade][indexItem]
    if (!item.itensATrabalhar) return

    if (val) {
      item.itensATrabalhar.selecionadas.push(competencia)
    } else {
      item.itensATrabalhar.selecionadas = item.itensATrabalhar.selecionadas.filter(e => e !== competencia)
    }
    setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], indexItem, item) })
  }

  function UpdateAvaliador(form: iPostAvaliador): void {
    appApi.put(`AvaliacaoPesquisa/${Temp?.avaliacaoId ?? ''}/avaliador/${Temp?.avaliador?.id ?? ''}`, form)
      .then(() => {
        toast({
          title: 'Avaliador atualizado com sucesso!',
          status: 'success',
          position: 'top',
          duration: 4000
        })
        onGetItemById(Temp?.itemId ?? '')
        onCloseModalAddParticipante()
      })
      .catch(() => {
        toast({
          title: 'Há campos sem preenchimento',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 2000
        })
      })
  }

  function ReenviarConviteAvaliador(avaliacaoId: string, avaliador?: iAvaliador): void {
    appApi.post(`AvaliacaoPesquisa/${avaliacaoId}/Reenviar?avaliadorId=${avaliador?.id ?? ''}`)
      .then(() => {
        toast({
          title: 'Reenviado com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 2000
        })
        onCloseModalAddParticipante()
      })
      .catch(() => {
        toast({
          title: 'Erro',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 2000
        })
      })
  }

  function getDashboard(firstReq?: boolean): void {
    setIsLoading(true)
    appApi.get(`FeedbackPersonalizado/${id}/Dashboard/${participanteId}/Participante`)
      .then(res => {
        const dash = res.data as iModel
        setModel({
          ...dash,
          entrada: dash.entrada.map(MarcarIncoerenciaItem),
          desenvolvimento: dash.desenvolvimento.map(MarcarIncoerenciaItem)
        })
        if (firstReq && query.get('itemId')) {
          setItemAtual(query.get('itemId') ?? '')
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => setIsLoading(false))
  }

  function onUpdateDataFimItem(novaDataFim: string): void {
    setIsLoading(true)
    appApi.patch(`FeedbackPersonalizado/${id}/Item/${DataFimUpdate?.itemId}/DataFim?participanteId=${Model?.participante.id}&dataFim=${novaDataFim}`)
      .then(res => {
        toast({
          title: 'Prazo para preenchimento extendido com sucesso!',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
        onGetItemById(DataFimUpdate?.itemId ?? '')
        setDataFimUpdate(undefined)
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => setIsLoading(false))
  }

  function onUpdateRespostasFormulario(itemId: string, pesquisaId: string, minhasRespostas: iMinhaResposta[]): void {
    setIsLoadingItem(true)
    appApi.put(`PesquisaInternaConvite/${pesquisaId}?comentario=${ComentarioItem.find(e => e.id === itemId)?.texto ?? ''}&feedbackId=${id ?? ''}&itemFeedbackId=${itemId}`, minhasRespostas)
      .then(res => {
        toast({
          title: 'Respostas atualizadas com sucesso!',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
        setModoEdicao([])
        setComentarioItem([])
        onGetItemById(itemId)
      })
      .catch(err => {
        console.log(err)
        setIsLoadingItem(false)
      })
  }

  function OnChangeTabGrafico(avalId: string, val: number): void {
    const pos = TabGrafico.findIndex(e => e.avalId === avalId)
    if (pos === -1) {
      setTabGrafico([...TabGrafico, { avalId: avalId, tab: val }])
    } else {
      setTabGrafico(UpdateElementByPosition(TabGrafico, pos, { avalId: avalId, tab: val }))
    }
  }

  function AlterarVisibiliade(itemId: string, avaliacaoId: string, visibilidade: boolean): void {
    setIsLoading(true)
    appApi.patch(`AvaliacaoPesquisa/${avaliacaoId}/AlterarVisibilidade?visibilidade=${visibilidade ? 0 : 1}`)
      .then(() => {
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function AlterarVisibiliadeInterna(itemId: string, visibilidade: boolean): void {
    setIsLoading(true)
    appApi.patch(`FeedbackPersonalizado/${id}/Item/${itemId}/AlterarVisibilidade?visibilidade=${visibilidade}&participanteId=${participanteId}`)
      .then(() => {
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function AlterarVisibiliadeFeedback(visibilidade: boolean): void {
    setIsLoading(true)
    appApi.patch(`FeedbackPersonalizado/${id}/AlterarVisibilidade?visibilidade=${visibilidade}&participanteId=${participanteId}`)
      .then(() => {
        getDashboard()
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function VerificarErrosAcoes(itemId: string, pdi: iPDI): boolean {
    if (!Model) return true

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const indexItem = Model[propriedade].findIndex(e => e.id === itemId)
    const item = Model[propriedade][indexItem]

    const comErros = pdi.acoes.filter(e =>
      e.dataFim === '' || e.dataFim === undefined ||
      (e.dataFim === null) ||
      e.tipo === 0 ||
      (e.tipo === 1 && e.competenciaId === undefined) ||
      (e.tipo === 2 && (e.assunto === '' || e.assunto === undefined)) ||
      (!e.colaboradorAcao && (e.dataInicio === undefined || e.dataInicio === null || e.dataInicio === ''))
    )
    const copy = [...pdi.acoes]
    comErros.forEach((e) => {
      copy[copy.indexOf(e)] = { ...e, temErro: true }
      setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], indexItem, { ...item, pdi: { ...pdi, acoes: copy } }) })
    })
    return comErros.length > 0
  }

  function EnviarPDI(itemId: string, pdi: iPDI): void {
    if (VerificarErrosAcoes(itemId, pdi)) {
      toast({
        title: 'Busque por ações de cor vermelha e verifique se todos os campos foram preenchidos',
        status: 'error',
        isClosable: false,
        position: 'top-right'
      })
      return
    }

    const form: iPostPDI = {
      colaboradorId: Model?.participante.id,
      origem: pdi.origem,
      responsavelId: Model?.responsavel.id,
      origemId: itemId,
      acoes: pdi.acoes.map((e) => {
        const model: iPostAcao = {
          id: e.id,
          dataFim: e.dataFim,
          descricao: e.descricao ?? '',
          motivo: e.motivo ?? '',
          permitirAlteracao: parseJwt().cid === Model?.participante.id ? true : e.colaboradorAcao,
          titulo: e.titulo ?? '',
          assunto: e.assunto,
          competenciaId: e.competenciaId,
          dataInicio: e.dataInicio,
          horas: parseInt(e.hora ?? '0')
        }
        return model
      })
    }

    appApi.post('PDI?salvar=false', form)
      .then(() => {
        toast({
          title: 'PDI cadastrado com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right'
        })
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
  }

  function AtualizarPDI(itemId: string, pdi: iPDI): void {
    if (VerificarErrosAcoes(itemId, pdi)) {
      toast({
        title: 'Busque por ações de cor vermelha e verifique se todos os campos foram preenchidos',
        status: 'error',
        isClosable: false,
        position: 'top-right'
      })
      return
    }

    const form: iPostAcao[] = pdi.acoes.map((e) => {
      const model: iPostAcao = {
        id: e.id,
        dataInicio: PropInvalida(e.dataInicio) ? undefined : e.dataInicio,
        dataFim: PropInvalida(e.dataFim) ? undefined : e.dataFim,
        descricao: e.descricao ?? '',
        motivo: e.motivo ?? '',
        permitirAlteracao: parseJwt().cid === Model?.participante.id ? true : e.colaboradorAcao,
        titulo: e.titulo ?? '',
        assunto: e.assunto,
        competenciaId: e.competenciaId,
        horas: parseInt(e.hora ?? '0')
      }
      return model
    })

    appApi.put(`PDI/${pdi.id as string}?salvar=false`, form)
      .then(() => {
        toast({
          title: 'Atualizações salvas com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right'
        })
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
  }

  function ObterTituloBtn(pdi?: iPDI): string {
    return (pdi?.podeAprovar === true || parseJwt().adm === 'True') ? 'Aprovar PDI' : 'Enviar PDI para aprovação'
  }

  function ActionClick(sair: boolean, itemId: string, pdi?: iPDI): void {
    if (!pdi) return

    if (pdi.acoes?.length === 0) {
      toast({
        title: 'Não selecionou nenhuma ação',
        status: 'error',
        isClosable: false,
        position: 'top-right'
      })
      return
    }

    const criar = pdi.status === 0

    if (AcoesPDIInput.length > 0) {
      appApi.post(`FeedbackPersonalizado/${id}/Participante/${participanteId}/Remanejar`, AcoesPDIInput)
        .then(() => {
          if (criar && !sair) {
            EnviarPDI(itemId, pdi)
          } else if (criar && sair) {
            SalvarSair(itemId, pdi)
          } else if (!criar && !sair) {
            AtualizarPDI(itemId, pdi)
          } else if (!criar && sair) {
            AtualizarSair(itemId, pdi)
          }
        })
        .catch((err) => console.log(err))
    } else {
      if (criar && !sair) {
        EnviarPDI(itemId, pdi)
      } else if (criar && sair) {
        SalvarSair(itemId, pdi)
      } else if (!criar && !sair) {
        AtualizarPDI(itemId, pdi)
      } else if (!criar && sair) {
        AtualizarSair(itemId, pdi)
      }
    }
  }

  function AtualizarSair(itemId: string, pdi: iPDI): void {
    if (VerificarErrosAcoes(itemId, pdi)) {
      toast({
        title: 'Busque por ações de cor vermelha e verifique se todos os campos foram preenchidos',
        status: 'error',
        isClosable: false,
        position: 'top-right'
      })
      return
    }

    const form: iPostAcao[] = pdi.acoes.map((e) => {
      const model: iPostAcao = {
        id: e.id,
        dataInicio: PropInvalida(e.dataInicio) ? undefined : e.dataInicio,
        dataFim: PropInvalida(e.dataFim) ? undefined : e.dataFim,
        descricao: e.descricao ?? '',
        motivo: e.motivo ?? '',
        permitirAlteracao: parseJwt().cid === Model?.participante.id ? true : e.colaboradorAcao,
        titulo: e.titulo ?? '',
        assunto: e.assunto,
        competenciaId: e.competenciaId,
        horas: parseInt(e.hora ?? '0')
      }
      return model
    })

    appApi.put(`PDI/${pdi.id as string}/?salvar=true`, form)
      .then(() => {
        toast({
          title: 'Atualizações salvas com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right'
        })
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
  }

  function SalvarSair(itemId: string, pdi: iPDI): void {
    if (pdi.acoes?.length === 0) {
      toast({
        title: 'Não selecionou nenhuma ação',
        status: 'error',
        isClosable: false,
        position: 'top-right'
      })
      return
    }

    if (VerificarErrosAcoes(itemId, pdi)) {
      toast({
        title: 'Busque por ações de cor vermelha e verifique se todos os campos foram preenchidos',
        status: 'error',
        isClosable: false,
        position: 'top-right'
      })
      return
    }

    const form: iPostPDI = {
      colaboradorId: Model?.participante.id,
      origem: pdi.origem,
      responsavelId: Model?.responsavel.id,
      origemId: itemId,
      acoes: pdi.acoes.map((e) => {
        const model: iPostAcao = {
          id: e.id,
          dataInicio: PropInvalida(e.dataInicio) ? undefined : e.dataInicio,
          dataFim: PropInvalida(e.dataFim) ? undefined : e.dataFim,
          descricao: e.descricao ?? '',
          motivo: e.motivo ?? '',
          permitirAlteracao: parseJwt().cid === Model?.participante.id ? true : e.colaboradorAcao,
          titulo: e.titulo ?? '',
          assunto: e.assunto,
          competenciaId: e.competenciaId,
          horas: parseInt(e.hora ?? '0')
        }
        return model
      })
    }

    appApi.post('PDI/?salvar=true&sair=true', form)
      .then(() => {
        toast({
          title: 'PDI salvo com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right'
        })
        onGetItemById(itemId)
      })
      .catch(err => console.log(err))
  }

  function GetParticipantesAvaliacao(avaliacao: iAvaliacaoDashResponse, id: string): any {
    if (!avaliacao || !IsGestorOrADM()) return <></>
    const isFromCalibracao = Model?.desenvolvimento.some(e => e.tipo === 13 && e.avaliacaoCalibracaoId === avaliacao.id)

    return <Flex flexDir={'column'} gap={'.5rem'}>
            <Flex justifyContent={'space-between'}>
              <Flex alignItems={'center'} gap={'.325rem'} fontSize={'14px'}>
                {avaliacao.autoAvaliacao?.respondido ? <><FaRegCheckCircle color='var(--Green2)' /> Autoavaliação respondida</> : <><FaRegTimesCircle color='var(--Red)'/> Autoavaliação pendente</>}
              </Flex>
              {GetParticipantesPendentes(avaliacao)}
            </Flex>

            <SectionAssociados>
                  <HeaderSection>
                      <h4>Gestor({avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 1).length > 0 ? avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 1).length : 0})</h4>
                      {!avaliacao.encerrada && parseJwt().adm === 'True' && <ButtonCmp VarColor='Rosa' onClick={() => onOpenModal(1, id, avaliacao?.id ?? '')}>Adicionar</ButtonCmp>}
                  </HeaderSection>
                  <SectionBody>
                      {
                          avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 1).map((e, i) => {
                            return (
                                  <CardAssociado
                                      key={i}
                                      avaliador={e}
                                      onEdit={(e) => onOpenModalEditarParticipante(avaliacao?.id ?? '', e, id)}
                                      tipo={1}
                                      isFromCalibracao={parseJwt().adm !== 'True'}
                                      encerrada={avaliacao?.encerrada ?? false}
                                  />
                            )
                          })
                      }
                  </SectionBody>
            </SectionAssociados>

            {!isFromCalibracao && <>
              <SectionAssociados>
                    <HeaderSection>
                        <h4>Pares({avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 2).length > 0 ? avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 2).length : 0})</h4>
                        {!avaliacao.encerrada && parseJwt().adm === 'True' && <ButtonCmp VarColor='Rosa' onClick={() => onOpenModal(2, id, avaliacao?.id ?? '')}>Adicionar</ButtonCmp>}
                    </HeaderSection>
                    <SectionBody>
                        {
                            avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 2).map((e, i) => {
                              return (
                                    <CardAssociado
                                        key={i}
                                        avaliador={e}
                                        onEdit={(e) => onOpenModalEditarParticipante(avaliacao?.id ?? '', e, id)}
                                        tipo={2}
                                        isFromCalibracao={parseJwt().adm !== 'True'}
                                        encerrada={avaliacao?.encerrada ?? false}
                                    />
                              )
                            })
                        }
                    </SectionBody>
              </SectionAssociados>

              <SectionAssociados>
                    <HeaderSection>
                        <h4>Outros({avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 4).length > 0 ? avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 4).length : 0})</h4>
                        {!avaliacao.encerrada && parseJwt().adm === 'True' && <ButtonCmp VarColor='Rosa' onClick={() => onOpenModal(4, id, avaliacao?.id ?? '')}>Adicionar</ButtonCmp>}
                    </HeaderSection>
                    <SectionBody>
                        {
                            avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 4).map((e, i) => {
                              return (
                                    <CardAssociado
                                        key={i}
                                        avaliador={e}
                                        onEdit={(e) => onOpenModalEditarParticipante(avaliacao?.id ?? '', e, id)}
                                        tipo={4}
                                        isFromCalibracao={parseJwt().adm !== 'True'}
                                        encerrada={avaliacao?.encerrada ?? false}
                                    />
                              )
                            })
                        }
                    </SectionBody>
              </SectionAssociados>

              <SectionAssociados>
                    <HeaderSection>
                        <h4>Alta liderança({avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 6).length > 0 ? avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 6).length : 0})</h4>
                        {!avaliacao.encerrada && parseJwt().adm === 'True' && <ButtonCmp VarColor='Rosa' onClick={() => onOpenModal(6, id, avaliacao?.id ?? '')}>Adicionar</ButtonCmp>}
                    </HeaderSection>
                    <SectionBody>
                        {
                            avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 6).map((e, i) => {
                              return (
                                    <CardAssociado
                                        key={i}
                                        avaliador={e}
                                        onEdit={(e) => onOpenModalEditarParticipante(avaliacao?.id ?? '', e, id)}
                                        tipo={6}
                                        isFromCalibracao={parseJwt().adm !== 'True'}
                                        encerrada={avaliacao?.encerrada ?? false}
                                    />
                              )
                            })
                        }
                    </SectionBody>
              </SectionAssociados>

              <SectionAssociados>
                    <HeaderSection>
                        <h4>Liderados({avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 3).length > 0 ? avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 3).length : 0})</h4>
                        {!avaliacao.encerrada && parseJwt().adm === 'True' && <ButtonCmp VarColor='Rosa' onClick={() => onOpenModal(3, id, avaliacao?.id ?? '')}>Adicionar</ButtonCmp>}
                    </HeaderSection>
                    <SectionBody>
                        {
                          avaliacao?.avaliadores.filter(aval => aval.tipoAvaliador === 3).map((e, i) => {
                            return (
                                  <CardAssociado
                                      key={i}
                                      avaliador={e}
                                      onEdit={(e) => onOpenModalEditarParticipante(avaliacao?.id ?? '', e, id)}
                                      tipo={3}
                                      isFromCalibracao={parseJwt().adm !== 'True'}
                                      encerrada={avaliacao?.encerrada ?? false}
                                  />
                            )
                          })
                        }
                    </SectionBody>
              </SectionAssociados>
            </>}

            {!avaliacao.encerrada && <Flex gap={'.325rem'} fontSize={'14px'} alignItems={'center'}>
              <FiMail color='var(--Azul)'/>
              <Text fontWeight={'400'}>Datas programadas para o reenvio de e-mails aos destinatários que ainda não responderam: </Text>
              {avaliacao.datasReenvio?.map((data, i) => {
                return <><Text fontWeight={'600'}>{data} </Text><Text fontWeight={600}>{(i + 1) === avaliacao?.datasReenvio.length ? '' : '-'}</Text></>
              })}
            </Flex>}
          </Flex>
  }

  function GetResumoCompetencias(resumoCompetencias: iCompetenciaPDI[], status: number, noBorder?: boolean): any {
    let color: string = ''
    let text: string = ''
    let icon: any = <></>
    switch (status) {
      case 1:
        color = 'var(--Green2)'
        text = 'Competências consideradas os maiores destaques positivos do avaliado na posição atual'
        icon = <FaMedal/>
        break

      case 2:
        color = 'var(--Azul)'
        text = 'Você mais se motiva'
        icon = <FaHeart/>
        break

      case 3:
        color = 'var(--Roxo)'
        text = 'Você menos se motiva'
        icon = <FaFrown/>
        break

      case 0:
        color = 'var(--Orange)'
        text = 'Competências consideradas prioridades de desenvolvimento do avaliado na função atual'
        icon = <FaTools />
        break
    }
    const arr = resumoCompetencias.filter(e => e.status === status)

    return <Box borderBottom={noBorder ? '' : '2px dashed var(--Azul)'} mt={'1.25rem'} pb={'1.5rem'} height={'100%'}>
      <Flex
        mb={'.75rem'}
        alignItems={'center'}
        gap={'.625rem'}
        fontWeight={'700'}
        color={color}
      >
        {icon} {text}
      </Flex>

      <Grid gridTemplateColumns={'repeat(2, 1fr)'} gap={'1.5rem'} height={'80%'}>
        {arr.map((e, i) => {
          return (
            <Flex key={i} fontWeight={'600'} alignItems={'center'} bg={'var(--c3)'} boxShadow={'var(--SombraBackground)'} borderRadius={'0 .25rem .25rem 0'} fontSize={'.875rem'}>
              <Flex flexDir={'column'} alignItems={'center'} justifyContent={'center'} w={'9rem'} py={'.75rem'} px={'1rem'} color={'white'} bg={color} borderRadius={'.25rem 0 0 .25rem'} h={'full'}>
                <Img w={'5rem'} h={'5rem'} p={'.5rem'} borderRadius={'50%'} src={e.avatar} />
                <Text mt={0} lineHeight={'.813rem'} textAlign={'center'} fontWeight={'900'}>{e.nome.replace('Autodesenvolvimento', 'Autodesenvol- vimento').replace('/', ' / ')}</Text>
              </Flex>
              <Box px={'1rem'} py={'1rem'} flex={'1'}>
                <Text fontWeight={'500'}><strong style={{ fontWeight: 800 }}>Descrição:</strong> {e.descricao}</Text>
              </Box>
            </Flex>
          )
        })}
      </Grid>
    </Box>
  }

  function ReturnNotaPDI(acaoId: string, avaliacoes?: iAvaliacoes[]): any {
    if (!avaliacoes) {
      return <></>
    }
    const notas = avaliacoes?.find(e => e.notas.some(a => a.acaoId === acaoId))?.notas
    if (notas) {
      const notaFinal = notas.find(e => e.acaoId === acaoId)?.nota
      switch (notaFinal) {
        case 1:
          return (
            <Flex fontSize={'14px'} gap={'.325rem'} alignItems={'center'} fontWeight={'500'} mt={'.75rem'}>
                <Flex h={'25px'}>Avaliação final:</Flex>
                <Emoji
                flexDir='row'
                texto='Não melhorou em nada'
                icon={IconeTriste}
                />
            </Flex>
          )
        case 2:
          return (
            <Flex fontSize={'14px'} gap={'.325rem'} alignItems={'center'} fontWeight={'500'} mt={'.75rem'}>
                <Flex h={'25px'}>Avaliação final:</Flex>
                <Emoji
                flexDir='row'
                texto='Precisa se esforçar mais'
                icon={IconeMagoado}
                />
            </Flex>
          )
        case 3:
          return (
            <Flex fontSize={'14px'} gap={'.325rem'} alignItems={'center'} fontWeight={'500'} mt={'.75rem'}>
                <Flex h={'25px'}>Avaliação final:</Flex>
                <Emoji
                flexDir='row'
                texto='Está no caminho certo'
                icon={IconeFeliz}
                />
            </Flex>
          )
        case 4:
          return (
            <Flex fontSize={'14px'} gap={'.325rem'} alignItems={'center'} fontWeight={'500'} mt={'.75rem'}>
                <Flex h={'25px'}>Avaliação final:</Flex>
                <Emoji
                flexDir='row'
                texto='Já melhorou muito'
                icon={IconePiscada}
                />
            </Flex>
          )
        case 5:
          return (
            <Flex fontSize={'14px'} gap={'.325rem'} alignItems={'center'} fontWeight={'500'} mt={'.75rem'}>
                <Flex h={'25px'}>Avaliação final:</Flex>
                <Emoji
                    flexDir='row'
                    texto='Já atingiu o esperado'
                    icon={IconeLove}
                />
            </Flex>
          )
        default:
          return <></>
      }
    }
    return <></>
  }

  function OnChangeProgressos(acaoId: string, porcentagemProgresso: number, observacaoProgresso?: string): void {
    const index = Progressos.findIndex(e => e.acaoId === acaoId)
    if (index !== -1) {
      const copy = Progressos
      copy[index].observacaoProgresso = observacaoProgresso
      copy[index].porcentagemProgresso = porcentagemProgresso
      setProgressos(Progressos)
    } else {
      setProgressos([...Progressos, { acaoId: acaoId, porcentagemProgresso: porcentagemProgresso, observacaoProgresso: observacaoProgresso }])
    }
  }

  function AtualizarAcao(itemId: string, acao: iPDIAcao, pdiInput?: iPDI): void {
    if (!Model || !pdiInput) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const copy = [...pdiInput.acoes]
    const pos = copy.findIndex(e => e.id === acao.id)
    if (pos !== -1) {
      const index = Model[propriedade].findIndex(e => e.id === itemId)
      const item = Model[propriedade][index]
      copy[pos] = acao
      setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, pdi: { ...pdiInput, acoes: copy } }) })
    }
  }

  function AtualizarAcaoAprovar(itemId: string, acao: iAcao, acoes?: iAcao[]): void {
    if (!Model || !acoes) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const copy = [...acoes]
    const pos = copy.findIndex(e => e.id === acao.id)
    if (pos !== -1) {
      const index = Model[propriedade].findIndex(e => e.id === itemId)
      const item = Model[propriedade][index]
      copy[pos] = acao
      setModel({ ...Model, [propriedade]: UpdateElementByPosition(Model[propriedade], index, { ...item, acoesParaAprovar: copy }) })
    }
  }

  function ReturnItensAvaliacao(item: iItemDashResponse, index: number): any {
    if (!item.avaliacao) return <></>

    return <Flex flexDir={'column'} gap={'1rem'} w={'100%'}>
      <Flex justifyContent={'space-between'} alignItems={'start'}>
        <Flex flexDir={'column'} gap={'.125rem'}>
          <h3>{item.avaliacao?.nomePesquisa} - {Model?.participante.nome}</h3>
          <Flex gap={'.75rem'} fontSize={'.875rem'} color={'var(--Gray3)'} fontWeight={'400'}>
            {item.tipo !== 13 && <>
              <Text>Data de início: <strong>{item.avaliacao.dataInicio}</strong></Text>
              <Text fontWeight={700}>-</Text>
              <Text>Data de término: <strong>{item.avaliacao.dataFim}</strong></Text>
            </>}
            {item.tipo === 13 && <Text>Data de realização da calibração: <strong>{item.avaliacao.dataCalibracao}</strong></Text>}
          </Flex>
        </Flex>
        <Flex gap={'1rem'} justifyContent={'end'}>
          {!item.avaliacao.encerrada && item.avaliacao.iniciarAntes && IsGestorOrADM() && <ButtonCmp VarColor='Green2' leftIcon={<FaCalendar/>} onClick={() => AdiantarItem(item.id)}>Iniciar item agora</ButtonCmp>}
          {!item.avaliacao.encerrada && item.avaliacao.extenderPrazo && parseJwt().adm === 'True' && <ButtonCmp VarColor='Green2' leftIcon={<FaCalendar/>} onClick={() => setDataFimUpdate({ dataFim: item.avaliacao?.dataFim ?? '', itemId: item.id })}>Extender prazo de preenchimento</ButtonCmp>}
          {!item.avaliacao.encerrada && !item.avaliacao.iniciarAntes && IsGestorOrADM() && <Flex flexDir={'column'} gap={'.75rem'}>
            <ButtonCmp VarColor='Rosa' leftIcon={<FiMail/>} onClick={() => ReenviarNaoRespondidos(item.idExterno ?? '')}>Reenviar convites não respondidos</ButtonCmp>
            {parseJwt().adm === 'True' && <ButtonCmp VarColor='Red' leftIcon={<FaRegStopCircle/>} onClick={() => onOpenModalEncerrar(item.avaliacao?.id ?? '', item.idExterno ?? '', item.id)}>Encerrar avaliação</ButtonCmp>}
          </Flex>}
          {!Model?.dashboard.concluido && item.tipo !== 13 && (item.avaliacao.encerrada && parseJwt().adm === 'True') && (
              <ButtonCmp
                  leftIcon={<FaRegPlayCircle />}
                  OutlineColor={'Rosa'}
                  onClick={() => ReabrirAvaliacao(item.avaliacao?.id ?? '', item.idExterno ?? '', item.id)}
              >Reabrir avaliação</ButtonCmp>
          )}
          {!Model?.dashboard.concluido && item.tipo === 13 && (item.avaliacao.encerrada) && (
              <ButtonCmp
                  leftIcon={IsGestorOrADM() ? <FaPencilAlt /> : <FaEye/>}
                  VarColor={'Roxo'}
                  onClick={() => OnRealizarCalibracao(item, index)}
              >{IsGestorOrADM() ? 'Editar calibração' : 'Alterar visualização'}</ButtonCmp>
          )}
          {item.avaliacao.encerrada && (item.avaliacao.resultadoQuantitativa || item.avaliacao.resultadoIndicativa) && <Flex flexDir={'column'} gap={'.5rem'}>
              <ButtonCmp VarColor='Green2' leftIcon={<BsGraphUp/>} onClick={() => nav(`/Desempenho/AnaliseDesempenho/${(item.tipo === 3 || item.tipo === 13) ? 'Quantitativa' : 'Indicativa'}/ResultadoIndividual/${item.avaliacao?.id}`)} isDisabled={item?.avaliacao?.avaliadores.filter(e => e.respondido).length === 0}>Visualizar resultados</ButtonCmp>
              {(item.avaliacao.liberarResultado === 0 && IsGestorOrADM()) && (
                <ButtonCmp
                  borderRadius={'.5rem'}
                  VarColor='Rosa'
                  leftIcon={<FaEyeSlash />}
                  onClick={() => AlterarVisibiliade(item.id, item.avaliacao?.id ?? '', false)}
                >Ocultar resultado</ButtonCmp>
              )}

              {(item.avaliacao.liberarResultado === 1 && IsGestorOrADM()) && (
                  <ButtonCmp
                    leftIcon={<FaEye />}
                    borderRadius={'.5rem'}
                    VarColor='Rosa'
                    onClick={() => AlterarVisibiliade(item.id, item.avaliacao?.id ?? '', true)}
                  >Liberar resultado</ButtonCmp>
              )}
            </Flex>}
          </Flex>
      </Flex>
      {IsGestorOrADM() && item.tipo !== 13 && <AccordionContainer title='Participantes'>
        {GetParticipantesAvaliacao(item.avaliacao, item.id)}
        <Divider borderColor={'var(--c6)'} opacity={'.8'} mt={'1.5rem'} mb={'1rem'}/>
      </AccordionContainer>}
      {item.avaliacao.iniciarAntes && <Flex alignItems={'center'} justifyContent='center'>
          <ImgSah center textoPersonalizado='A pesquisa ainda não foi iniciada, aguarde para realizar o preenchimento da pesquisa'></ImgSah>
        </Flex>}
      {!item.avaliacao.iniciarAntes && item.avaliacao.linkResponder && <Flex alignItems={'center'} justifyContent='center'>
          <ImgSah center textoPersonalizado='A pesquisa está disponível para preenchimento, clique no botão abaixo para responder a pesquisa'>
            <ButtonCmp VarColor='Green2' big onClick={() => { window.location.href = item.avaliacao?.linkResponder ?? '' }}>Responder pesquisa</ButtonCmp>
          </ImgSah>
        </Flex>}
      {!item.avaliacao.iniciarAntes && !item.avaliacao.linkResponder && !item.avaliacao.resultadoQuantitativa && !item.avaliacao.resultadoIndicativa && <Flex alignItems={'center'} justifyContent='center'>
          <ImgSah center textoPersonalizado='Aguarde o encerramento da pesquisa para liberação dos resultados'>
          </ImgSah>
        </Flex>}
      {item.avaliacao.resultadoQuantitativa && <Flex flexDir={'column'} gap={'1rem'}>
        {item.tipo !== 13 && item.avaliacao.resultadoQuantitativa?.recomendacoes.length > 0 && <>
          <Titulo>Recomendações</Titulo>
          <Grid templateColumns={`repeat(${item.avaliacao.resultadoQuantitativa?.recomendacoes.length > 3 ? 3 : item.avaliacao.resultadoQuantitativa?.recomendacoes.length}, 1fr)`} gap={'1rem'}>
            {
              item.avaliacao.resultadoQuantitativa?.recomendacoes.map((e, i) => {
                return (
                  <Recomendacao pos={i + 1} recomendacao={e} key={i} />
                )
              })
            }
          </Grid>
          <Divider borderColor={'var(--c6)'} opacity={'.8'} my={'.5rem'}/>
        </>}
        <GridContainer activeResponsive={item.tipo !== 13}>
          {item.tipo !== 13 && (!TabGrafico.find(e => e.avalId === item.avaliacao?.id) || TabGrafico.find(e => e.avalId === item.avaliacao?.id)?.tab === 0) && item.avaliacao.resultadoQuantitativa.graficoHierarquia && (
            <Flex flexDir={'column'} width='100%' h={'100%'}>
              <Flex justifyContent={'space-between'} gap={'.5rem'}>
                <Flex justifyContent={'space-between'} gap={'.35rem'} flex={'1'}>
                  <Flex gap={'.75rem'} flex={'1'}>
                    <Titulo>Gráfico de hierarquia</Titulo>
                  </Flex>
                  {(item.avaliacao.resultadoQuantitativa.graficoHierarquia) && (
                    <SwitchCmp value={TabGrafico.find(e => e.avalId === item.avaliacao?.id)?.tab === 1} OnChange={(e) => { OnChangeTabGrafico(item.avaliacao?.id ?? '', 1) }} legendaDireita={'Gráfico individual'} legendaEsquerda={'Gráfico de hierarquia'}/>
                  )}
                </Flex>
              </Flex>
              <LoadingContainer linhas={16} loading={IsLoadingIndividual} my={'1rem'}>
                <Flex justifyContent={'center'} width='100%' position={'relative'}>
                  <Flex w={'34rem'}>
                    <RadarChartJs
                      competencias={item.avaliacao.resultadoQuantitativa?.graficoHierarquia.competencias ?? []}
                      dados={item.avaliacao.resultadoQuantitativa?.graficoHierarquia.dados ?? []}
                      notaMinimaEscala={item.avaliacao.resultadoQuantitativa.escala?.respostas.sort((a, b) => a.peso - b.peso)[1]?.peso}
                      notaMaximaEscala={item.avaliacao.resultadoQuantitativa.escala?.respostas.sort((a, b) => a.peso - b.peso)[item.avaliacao.resultadoQuantitativa.escala?.respostas.length - 1]?.peso}
                      stepSize={item.avaliacao.resultadoQuantitativa.escala?.respostas.some(e => e.peso === 7.5) ? 2.5 : 2}
                    />
                  </Flex>
                </Flex>
              </LoadingContainer>
            </Flex>)
          }

          {item.tipo !== 13 && TabGrafico.find(e => e.avalId === item.avaliacao?.id)?.tab === 1 && item.avaliacao.resultadoQuantitativa.graficoIndividual && (
            <Flex flexDir={'column'} width='100%' h={'100%'}>
              <Flex justifyContent={'space-between'}>
                  <Flex w={'full'} gap={'.5rem'}>
                    <Flex justifyContent={'space-between'} gap={'.35rem'} flex={'1'} w={'100%'}>
                      <Flex gap={'.75rem'} flex={'1'}>
                        <Titulo>Gráfico individual</Titulo>
                      </Flex>
                      {(item.avaliacao.resultadoQuantitativa.graficoIndividual) && (
                        <SwitchCmp value={TabGrafico.find(e => e.avalId === item.avaliacao?.id)?.tab === 1} OnChange={(e) => { OnChangeTabGrafico(item.avaliacao?.id ?? '', 0) }} legendaDireita={'Gráfico individual'} legendaEsquerda={'Gráfico de hierarquia'}/>
                      )}
                    </Flex>
                  </Flex>
              </Flex>
              <LoadingContainer linhas={16} loading={IsLoadingIndividual} my={'1rem'}>
                <Flex justifyContent={'center'} width='100%' position={'relative'}>
                  <Flex w={'34rem'}>
                      <RadarChartJs
                        competencias={item.avaliacao.resultadoQuantitativa.graficoIndividual.competencias ?? []}
                        dados={item.avaliacao.resultadoQuantitativa.graficoIndividual.dados ?? []}
                        notaMinimaEscala={item.avaliacao.resultadoQuantitativa.escala?.respostas.sort((a, b) => a.peso - b.peso)[1]?.peso}
                        notaMaximaEscala={item.avaliacao.resultadoQuantitativa.escala?.respostas.sort((a, b) => a.peso - b.peso)[item.avaliacao.resultadoQuantitativa.escala?.respostas.length - 1]?.peso}
                        stepSize={item.avaliacao.resultadoQuantitativa.escala?.respostas.some(e => e.peso === 7.5) ? 2.5 : 2}
                      />
                  </Flex>
                </Flex>
              </LoadingContainer>
            </Flex>)
          }
          {item.tipo !== 13 && <Divider height={Width < 1599 ? '' : '100%'} borderColor={'var(--c6)'} opacity={'.8'} orientation={Width < 1599 ? 'horizontal' : 'vertical'}/>}
          <Flex flexDir={'column'} gap={'1.5rem'} alignItems={'start'} h={'full'}>
            <Titulo>Tabela dos resultados por hierarquia</Titulo>
            <Tabela
              cores={item.avaliacao.resultadoQuantitativa.cores}
              discursivas={item.avaliacao.resultadoQuantitativa.discursivas}
              linhas={item.avaliacao.resultadoQuantitativa.tabela}
              mediaGeral={item.avaliacao.resultadoQuantitativa.mediaGeral}
              recomendacoes={item.avaliacao.resultadoQuantitativa.recomendacoes}
              temColuna={(tipo) => TemColuna(tipo, item.avaliacao?.resultadoQuantitativa?.participantes ?? [])}
              apenasAutoAvaliacao={item.avaliacao.resultadoQuantitativa.apenasAutoAvaliacao}
            />
            <Flex mt={'.5rem'} flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
              {item.avaliacao.resultadoQuantitativa.escala?.respostas.sort((a, b) => b.peso - a.peso).map((e, i) => {
                return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
              })}
            </Flex>
            <Flex justifyContent={'center'} gap={'1rem'} w={'100%'}>
              <Flex alignItems={'center'} gap={'.25rem'} fontSize={'.85rem'}>
                <Box w={'.65rem'} h={'.65rem'} bgColor={'var(--Orange)'}></Box>
                Notas mais baixas
              </Flex>
              <Flex alignItems={'center'} gap={'.25rem'} fontSize={'.85rem'}>
                <Box w={'.65rem'} h={'.65rem'} bgColor={'#00aa00'}></Box>
                Notas mais altas
              </Flex>
            </Flex>
          </Flex>
        </GridContainer>
      </Flex>}
      {item.avaliacao.resultadoIndicativa && <Flex flexDir={'column'} gap={'1rem'}>
        <Grid alignItems={'center'} gridTemplateColumns={`${Width > 1599 ? '1fr 1rem 1fr' : '1fr'}`} gap={'1.5rem'} h={'100%'}>
          {GetResumoCompetencias(item.avaliacao.resultadoIndicativa.resumoCompetencias, 0)}
          {Width > 1599 && <Divider height={'90%'} borderColor={'var(--c6)'} opacity={'.8'} orientation={'vertical'}/>}
          {GetResumoCompetencias(item.avaliacao.resultadoIndicativa.resumoCompetencias, 1)}
          {GetResumoCompetencias(item.avaliacao.resultadoIndicativa.resumoCompetencias, 2, Width > 1599)}
          {Width > 1599 && <Divider height={'90%'} borderColor={'var(--c6)'} opacity={'.8'} orientation={'vertical'}/>}
          {GetResumoCompetencias(item.avaliacao.resultadoIndicativa.resumoCompetencias, 3, true)}
        </Grid>
        <Divider borderColor={'var(--c6)'} opacity={'.8'} mb={'.5rem'} orientation={'horizontal'}/>
        <TabelaIndicativa modelo={item.avaliacao.resultadoIndicativa}/>
      </Flex>}
    </Flex>
  }

  function OnUpdateComentarioTexto(val: string, itemId: string): void {
    const index = ComentarioItem.findIndex(e => e.id === itemId)
    if (index !== -1) {
      setComentarioItem(UpdateElementByPosition(ComentarioItem, index, { id: itemId, texto: val }))
    } else {
      setComentarioItem([...ComentarioItem, { id: itemId, texto: val }])
    }
  }

  function GetPontosDeDesenvolvimento(dashboard: iDashResponse, isItem: boolean): any {
    if (!Model) return

    const item = Model.desenvolvimento.find(e => e.tipo === 14)
    if (!item) return

    if (!dashboard?.competencias || dashboard?.competencias.length <= 0) return

    return (<Flex p={'.75rem 1.25rem'} borderRadius={'.25rem'} flexDir='column' gap={'1.75rem'} border={'1px solid var(--c6)'} w={'100%'}>
      <Flex justifyContent={'space-between'} alignItems={'center'}>
        <Text fontSize={'16px'} fontWeight={700}>Pontos de desenvolvimento</Text>
        {!dashboard.concluido && !isItem && <ButtonCmp onClick={() => { setItemAtual(item.id); setSelecionarNovamente([...SelecionarNovamente, item.id]); setFaseAtual(1) }} leftIcon={<FaTools/>} VarColor={'Green2'}>Modificar competências para melhoria</ButtonCmp>}
      </Flex>
      <Grid gridTemplateColumns={'repeat(3, 1fr)'} gap={'1rem'} h={'full'}>
        {dashboard?.competencias?.map((e, i) => {
          return <ItemATrabalhar pos={i + 1} hFull recomendacao={e}/>
        })}
      </Grid>
    </Flex>)
  }

  function GetAcoesEmAndamento(dashboard: iDashResponse, isItem: boolean): any {
    if (!Model) return

    const item = Model.desenvolvimento.find(e => e.tipo === 14)
    if (!item) return

    return (<Flex gap={'1.5rem'} flexDir='column' border={'1px solid var(--AzulOpaco)'} borderRadius={'.25rem'} p={'1.5rem'}>
      <Flex alignItems={'center'} justifyContent='space-between'>
        <Flex fontSize={'16px'} fontWeight={'700'}>Ações em andamento</Flex>
        {!isItem && <ButtonCmp VarColor='Green2' onClick={() => { setItemAtual(item.id); setFaseAtual(1) }}>Visualizar plano de ação</ButtonCmp>}
      </Flex>
      <Grid gridTemplateColumns={'repeat(3, 1fr)'} gap={'1.5rem'}>
        {dashboard.pdi?.acoes.map(e => {
          return (<AcaoCard acao={e}/>)
        })}
      </Grid>
    </Flex>)
  }

  function GetNineBox(dashboard: iDashResponse): any {
    const quadSelecionado = dashboard.nineBox.quadrantes.find(e => e.titulo === dashboard.calibracao?.nomeQuadrante)
    if (!quadSelecionado) return

    const eixoY = dashboard?.nineBox?.eixosX.find(e => e.id === quadSelecionado.eixoX)
    const eixoX = dashboard?.nineBox?.eixosY.find(e => e.id === quadSelecionado.eixoY)

    return (
      <Flex gap={'.75rem'} p={'.5rem 1rem'} border={'1px solid var(--c6)'} borderRadius={'.25rem'} alignItems='center' minW={'26rem'}>
          <Box backgroundColor={ObterCorQuadrantePorNome(dashboard.nineBox?.quadrantes ?? [], quadSelecionado.titulo ?? '')} w={'5.5rem'} h={'5.5rem'} display={'flex'} flexDirection={'column'} color={'#fff'} borderRadius={'.25rem'} justifyContent={'center'} alignItems={'center'}>
              <Text fontSize={'0.75rem'}>{quadSelecionado.titulo}</Text>
              <Image height={'3rem'} width={'3rem'} src={ObterImgPorNome(dashboard.nineBox?.quadrantes ?? [], quadSelecionado.titulo ?? '')} />
          </Box>
          <Flex flexDir={'column'} justifyContent={'center'} fontSize={'.875rem'}>
              <Text fontWeight={'700'}>Notas do 9Box</Text>
              <Text color={'var(--Azul)'}><strong style={{ fontWeight: 600 }}>{dashboard.nineBox.configuracaoEixoY.titulo} | {eixoY?.titulo} </strong> {dashboard.calibracao?.notaY === -1 ? '-' : dashboard.calibracao?.notaY}</Text>
              <Text color={'var(--Green2)'}><strong style={{ fontWeight: 600 }}>{dashboard.nineBox.configuracaoEixoX.titulo} | {eixoX?.titulo} </strong> {dashboard.calibracao?.notaX === -1 ? '-' : dashboard.calibracao?.notaX}</Text>
          </Flex>
      </Flex>
    )
  }

  function GetItemAtual(): any {
    const item = FaseAtual === 0 ? Model?.entrada.find(e => e.id === ItemAtual) : Model?.desenvolvimento.find(e => e.id === ItemAtual)
    const index = FaseAtual === 0 ? Model?.entrada.findIndex(e => e.id === ItemAtual) : Model?.desenvolvimento.findIndex(e => e.id === ItemAtual)

    if (Model && ((ItemAtual === '' && FaseAtual === -1 && Model?.dashboard) || (item?.tipo === 2))) {
      const dashboard = item?.tipo !== 2 ? Model?.dashboard : item?.feedbackAnterior
      if (!dashboard && item?.tipo === 2) {
        if (!ItensOpacosIds.includes(item.id)) {
          setItensOpacosIds([...ItensOpacosIds, item.id])
        }
        return (<Flex>
          <ImgSah center textoPersonalizado='Não foi encontrado nenhum feedback anterior para esse colaborador'></ImgSah>
        </Flex>)
      }
      if (!dashboard) return

      if (item && ItensOpacosIds.includes(item?.id)) {
        if (item && ItensOpacosIds.includes(item?.id)) {
          setItensOpacosIds([...ItensOpacosIds.filter(e => e !== item?.id)])
        }
      }
      return <Flex flexDir={'column'} gap={'1.5rem'} w={'100%'}>
        {item?.tipo === 2
          ? <Flex flexDir={'column'} gap={'.125rem'}>
          <h3>Feedback anterior</h3>
          <Flex gap={'.75rem'} fontSize={'.875rem'} color={'var(--Gray3)'} fontWeight={'400'}>
            <Text>Último fluxo personalizado realizado por esse colaborador</Text>
          </Flex>
        </Flex>
          : <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Flex flexDir={'column'} gap={'.125rem'}>
                <h3>Feedback</h3>
              <Flex gap={'.75rem'} fontSize={'.875rem'} color={'var(--Gray3)'} fontWeight={'400'}>
                <Text>Fluxo personalizado para realização do feedback, acesse o menu lateral para navegar nas diversas informações que compõe esse feedback.</Text>
            </Flex>
          </Flex>
          <Flex gap={'.75rem'}>
            {!dashboard.concluido && IsGestorOrADM() && Model.dashboard.resultadosLiberados === true && <ButtonCmp
              borderRadius={'.5rem'}
              VarColor='Rosa'
              leftIcon={<FaEyeSlash />}
              onClick={() => AlterarVisibiliadeFeedback(false)}
            >
              Ocultar resultados
            </ButtonCmp>}
            {!dashboard.concluido && IsGestorOrADM() && Model.dashboard.resultadosLiberados === false && <ButtonCmp
              leftIcon={<FaEye />}
              borderRadius={'.5rem'}
              VarColor='Rosa'
              onClick={() => AlterarVisibiliadeFeedback(true)}
            >
              Liberar resultados
            </ButtonCmp>}
            {dashboard.itensConcluidos && !dashboard.concluido && <ButtonCmp VarColor='Green2' onClick={() => ConcluirFeedback()}>Concluir feedback</ButtonCmp>}
          </Flex>
        </Flex>}
        {item?.tipo !== 2 && dashboard.itensPendentes?.map(e => {
          return (<Flex p={'.5rem 3rem'} w={'100%'} bg={'var(--AzulOpacoBg)'} border={'1px solid var(--c5)'} alignItems={'center'} boxShadow={'var(--SombraBackground)'} gap={'2rem'}>
            <Flex flexDir={'column'} lineHeight={'1rem'} gap={'.325rem'}>
              <Text fontSize={'.875rem'} fontWeight={400}>{e.titulo}</Text>
              <Text fontSize={'1rem'} fontWeight={600}>{e.mensagem}</Text>
            </Flex>
            <Divider orientation='vertical' h={'3rem'} borderColor={'black'} opacity={'.9'}/>
            {!e.url ? <ButtonCmp VarColor='Green2' onClick={() => { setItemAtual(e.id); Model.entrada.some(a => a.id === e.id) ? setFaseAtual(0) : setFaseAtual(1) }}>Realizar item</ButtonCmp> : <ButtonCmp VarColor='Green2' onClick={() => { window.location.href = e.url ?? '' }}>Responder pesquisa</ButtonCmp>}
          </Flex>)
        })}
        {!dashboard.itensPendentes && !dashboard.concluido && !dashboard.itensConcluidos && <Flex p={'1rem 3rem'} w={'100%'} bg={'var(--AzulOpacoBg)'} border={'1px solid var(--c5)'} alignItems={'center'} boxShadow={'var(--SombraBackground)'} gap={'2rem'} fontSize={'14px'} fontWeight={400}>Nenhum item pendente</Flex>}
        {(dashboard.itensConcluidos || dashboard.concluido) && (!dashboard.itensPendentes || dashboard.itensPendentes?.length === 0) && ItemAtual === '' && <Flex p={'.5rem 1.5rem'} w={'100%'} bg={'var(--Green2OpacoBg)'} border={'1px solid var(--Green2)'} alignItems={'center'} boxShadow={'var(--SombraBackground)'} gap={'.5rem'} fontSize={'14px'} fontWeight={400}><FaCheckCircle color={'var(--Green2)'}/> Todos os itens do feedback foram concluídos</Flex>}
        {(dashboard?.competencias || (Model.participante.perfilPI && dashboard.nineBox) || (dashboard.pontosPositivosNegativos && parseJwt().cid !== Model.participante.id)) && <Flex flexDir={'column'} gap={'1.5rem'} w={'100%'}>
          <Flex gap={'1rem'} w={'100%'}>
            {Model.participante.perfilPI && <DashBox theme={'Rosa'} style={{ marginBottom: '0', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <Flex justifyContent={'center'} pr={'1.75rem'}>
                    <span className='DashTitle'>Perfil comportamental</span>
                </Flex>
                <Flex gap={'2rem'} justifyContent={'center'} alignItems={'center'}>
                    <Flex marginBottom={'.5rem'} flexDir='column' alignItems={'center'}>
                        {
                            (Model.participante.perfilPI?.urlSelo) && (
                                <Image width={'3rem'} src={Model.participante.perfilPI.urlSelo} />
                            )
                        }
                        {
                            (Model.participante.perfilPI?.nomeSelo) && (
                                <Text marginBottom={'.5rem'} fontWeight={'600'} fontSize={'.875rem'}>{Model.participante.perfilPI?.nomeSelo}</Text>
                            )
                        }
                    </Flex>

                    <Flex justifyContent={'space-around'} mb={'-.5rem'}>
                        {
                            (Model.participante.perfilPI?.urlSelf) && (
                                <Image width={'16rem'} src={Model.participante.perfilPI.urlSelf} />
                            )
                        }
                    </Flex>

                    <Menu>
                        <MenuButton as={Button} color={'var(--Rosa)'} fontSize={'.875rem'} borderRadius={'.25rem'} height={'1.95rem'} bgColor='var(--c1)' border={'2px solid var(--Rosa)'} _hover={{ bgColor: 'white', color: 'var(--c1)', border: '2px', bg: 'var(--Rosa)' }} _active={{ bgColor: 'white', color: 'var(--c1)', border: '2px', bg: 'var(--Rosa)' }} mb={'.325rem'}>
                            <FaDownload style={{ marginRight: '.5rem' }}/> Relatorios
                        </MenuButton>
                        <MenuList bgColor='var(--Rosa)' boxShadow={'var(--SombraBtns)'}>
                            {
                                (!PropInvalida(Model.participante.perfilPI?.urlResultado)) && (
                                    <StyledMenuItem onClick={() => { window.location.href = Model.participante.perfilPI?.urlResultado ?? '#' }}>
                                        Perfil comportamental
                                    </StyledMenuItem>
                                )
                            }

                            {
                                (!PropInvalida(Model.participante.perfilPI?.urlQuadro)) && (
                                    <StyledMenuItem onClick={() => { window.location.href = Model.participante.perfilPI?.urlQuadro ?? '#' }}>
                                        Quadro desenvolvimento pessoal
                                    </StyledMenuItem>
                                )
                            }

                            {
                                (!PropInvalida(Model.participante.perfilPI?.urlPlacard)) && (
                                    <StyledMenuItem onClick={() => { window.location.href = Model.participante.perfilPI?.urlPlacard ?? '#' }}>
                                        Placard
                                    </StyledMenuItem>
                                )
                            }

                            {
                                (!PropInvalida(Model.participante.perfilPI?.urlQuadroGestor)) && (
                                    <StyledMenuItem onClick={() => { window.location.href = Model.participante.perfilPI?.urlQuadroGestor ?? '#' }}>
                                        Quadro desenvolvimento gestores
                                    </StyledMenuItem>
                                )
                            }

                        </MenuList>
                    </Menu>
                </Flex>
            </DashBox>}
            {dashboard.calibracao && GetNineBox(dashboard)}
            {dashboard.pontosPositivosNegativos && parseJwt().cid !== Model.participante.id && <Flex width={'100%'} border={'1px solid var(--c6)'} justifyContent={'center'} alignItems={'center'} flexDir='column' py={'1rem'} px={'1rem'}>
              <Text fontSize={'16px'} fontWeight={600}>Percepções sobre a empresa</Text>
              <Grid gridTemplateColumns={'1fr .25rem 1fr'} gap={'1.5rem'} alignItems={'center'} py={'1rem'}>
                <Flex flexDir={'column'} gap={'.325rem'} lineHeight={'14px'}>
                  <Text fontSize={'14px'} mb={'.5rem'} fontWeight={700}>Pontos positivos</Text>
                  {dashboard.pontosPositivosNegativos?.positivos.map(e => {
                    return <Text fontSize={'13px'} color={'var(--Green2)'} fontWeight={'600'}>- {e}</Text>
                  })}
                </Flex>
                <Divider orientation='vertical' h={'4.25rem'} opacity={'.9'} borderColor={'var(--Azul)'}/>
                <Flex flexDir={'column'} gap={'.325rem'} lineHeight={'14px'}>
                  <Text fontSize={'14px'} mb={'.5rem'} fontWeight={700}>Pontos de atenção</Text>
                  {dashboard.pontosPositivosNegativos?.negativos.map(e => {
                    return <Text fontSize={'13px'} color={'var(--Red)'} fontWeight={'600'}>- {e}</Text>
                  })}
                </Flex>
              </Grid>
            </Flex>}
          </Flex>
          {GetPontosDeDesenvolvimento(dashboard, item?.tipo === 2)}
        </Flex>}
        {dashboard.pdi && dashboard.pdi.acoes.length > 0 && GetAcoesEmAndamento(dashboard, item?.tipo === 2)}
        {dashboard.resultadoAvaliacoes && <Flex gap={'1rem'} flexDir='column' border={'1px solid var(--AzulOpaco)'} borderRadius={'.25rem'}>
          <Flex fontSize={'16px'} fontWeight={'700'} p={'1rem 1.25rem'}>Resultado das pesquisas de competências</Flex>
          <TabelaItensAMelhorar model={dashboard.resultadoAvaliacoes}/>
        </Flex>}
        {!dashboard.resultadoAvaliacoes && (!dashboard.pdi || dashboard.pdi.acoes.length === 0) && !dashboard?.competencias && !dashboard.pontosPositivosNegativos && <ImgSah center textoPersonalizado='Os itens que aparecem no Dashboard ainda não foram concluídos, espere que eles sejam preenchidos para visualizá-los aqui'></ImgSah>}
      </Flex>
    }

    if (item) {
      switch (item.tipo) {
        case 3:
        case 4:
          return ReturnItensAvaliacao(item, index ?? 0)

        case 1:
          if (item.ultimoPDI) {
            if (item && ItensOpacosIds.includes(item?.id)) {
              setItensOpacosIds([...ItensOpacosIds.filter(e => e !== item?.id)])
            }
            return <Flex flexDir={'column'} gap={'1rem'} w={'100%'}>
              <h3>Último PDI do {Model?.participante.nome}</h3>
              <Flex justifyContent={'space-between'}>
                <Flex gap={'2rem'}>
                  <Flex gap={'2rem'} bg={'var(--AzulOpacoBg)'} p={'.75rem 1rem'} fontSize={'14px'} border={'1px solid var(--Azul)'}justifyContent={'center'} borderRadius={'.25rem'} boxShadow={'var(--SombraBtns)'}>
                    <Flex flexDir={'column'} fontSize={'14px'}>
                      <FormLabel fontWeight={700} fontSize={'14px'}>Participante</FormLabel>
                      <CardPDI>
                        <Avatar size={'md'} marginRight={'1rem'} src={Model?.participante.avatar} name={Model?.participante.nome} />
                        <Flex flexDir={'column'}>
                          <Flex gap={'.25rem'}>Nome: <strong>{Model?.participante.nome}</strong></Flex>
                          <Flex gap={'.25rem'}>Área: <strong>{Model?.participante.complemento}</strong></Flex>
                        </Flex>
                      </CardPDI>
                    </Flex>
                    {(item.ultimoPDI.responsavel) && (
                      <>
                        <Divider orientation='vertical' borderColor={'var(--c6)'}/>
                        <Flex flexDir={'column'} fontSize={'14px'}>
                          <FormLabel fontWeight={700} fontSize={'14px'}>Responsável</FormLabel>
                          <CardPDI>
                            <Avatar size={'md'} marginRight={'1rem'} src={item.ultimoPDI.responsavel.avatar} name={item.ultimoPDI.responsavel.nome} />
                            <Flex flexDir={'column'}>
                              <Flex gap={'.25rem'}>Nome: <strong>{item.ultimoPDI.responsavel.nome}</strong></Flex>
                              <Flex gap={'.25rem'}>Área: <strong>{item.ultimoPDI.responsavel.departamento?.nome}</strong></Flex>
                            </Flex>
                          </CardPDI>
                        </Flex>
                      </>
                    )}
                  </Flex>
                  <Flex flexDir={'column'} bg={'var(--RosaOpacoBg)'} p={'.75rem 1rem'} fontSize={'14px'} border={'1px solid var(--Rosa)'}justifyContent={'center'} gap={'.15rem'} borderRadius={'.25rem'} boxShadow={'var(--SombraBtns)'}>
                    <Flex gap={'.3rem'} alignItems={'center'}>
                      <Flex fontWeight={'700'}>Origem do PDI: </Flex>
                      <Flex alignItems={'center'}>
                        {item.ultimoPDI.origem === 0 && 'Pesquisa'}
                        {item.ultimoPDI.origem === 1 && 'Feedback'}
                        {item.ultimoPDI.origem === 2 && 'Outra'}
                        {item.ultimoPDI.origem === 4 && 'Onboard'}
                      </Flex>
                    </Flex>
                    <Flex gap={'.3rem'} alignItems={'center'}>
                      <Flex fontWeight={'700'}>Status do PDI: </Flex>
                      <Flex alignItems={'center'}>
                        {item.ultimoPDI.status === 0 && 'Em edição'}
                        {item.ultimoPDI.status === 1 && 'Aguardando aprovação'}
                        {item.ultimoPDI.status === 2 && 'Aguardando alteração'}
                        {item.ultimoPDI.status === 3 && 'Aprovado'}
                        {item.ultimoPDI.status === 4 && 'Aguardando inicio'}
                        {item.ultimoPDI.status === 5 && 'Em andamento'}
                        {item.ultimoPDI.status === 6 && 'Atrasado'}
                        {item.ultimoPDI.status === 7 && 'Concluido'}
                      </Flex>
                    </Flex>
                    <Flex gap={'.3rem'} alignItems={'center'}>
                      <Flex fontWeight={'700'}>Total de ações: </Flex>
                      <Flex alignItems={'center'}>
                        {item.ultimoPDI.acoes.length}
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
                <ButtonCmp VarColor='Green2' onClick={() => nav(`/Desempenho/PDI/Editar/${item.ultimoPDI?.id}`)}>Visualizar PDI</ButtonCmp>
              </Flex>
              <Divider borderColor={'var(--c6)'} opacity={'.8'} mt={'1rem'} mb={'.5rem'}/>
              <Flex gap={'.325rem'} alignItems={'center'} fontWeight={700} fontSize='16px'>
                <TbTargetArrow size={20}/>
                Temas trabalhados
              </Flex>
              <Grid gridTemplateColumns={'1fr'} gap={'2rem'}>
                {item.ultimoPDI.acoes.map((acao, position) => {
                  return <Flex pos={'relative'}>
                    <Flex flexDir={'column'} color={'var(--c1) !important'} bg={'var(--Azul)'} gap={'2%'} p={'1rem'} minW={Width > 1599 ? '42%' : '30%'}>
                      <Text fontWeight={'800'} fontSize={'.913rem'} lineHeight={'1rem'}>{position + 1}ª Tema</Text>
                      <Flex gap={'.5rem'} flexDir='column' flexWrap={'wrap'} mt={'.75rem'}>

                        <FormControl w={'100%'}>
                            <FormLabel fontSize={'14px'} mb={'.25rem'} fontWeight={'700'}>Assunto</FormLabel>
                            <PDIText>{acao.assunto}</PDIText>
                        </FormControl>

                        <FormControl w={'100%'}>
                          <FormLabel fontSize={'14px'} mb={'.25rem'} fontWeight={'700'}>Horas a dedicar</FormLabel>
                          <PDIText>{acao.hora ? acao.hora : '0'}</PDIText>
                        </FormControl>

                        <FormControl w={'100%'}>
                          <FormLabel fontSize={'14px'} mb={'.25rem'} fontWeight={'700'}>Data para iniciar</FormLabel>
                          <PDIText>{acao.dataInicio}</PDIText>
                        </FormControl>

                        <FormControl w={'100%'}>
                          <FormLabel fontSize={'14px'} mb={'.25rem'} fontWeight={'700'}>Data para finalizar</FormLabel>
                          <PDIText>{acao.dataFim}</PDIText>
                        </FormControl>
                      </Flex>
                    </Flex>

                    <Flex gap={'2%'} flexDir={'column'} py={'1rem'} pr='1rem' w={'100%'} border={'2px solid var(--c3)'} borderLeft={'none'} pl={'1.5rem'}>
                        <Flex alignItems={'end'} pos={'absolute'} top={'1.375rem'} right={'1rem'}>
                              {
                                  (acao.status === 1 || acao.status === 2) && (
                                      <Flex alignItems={'center'} color='var(--Yellow)' flexDir={'column'}>
                                          <FaPauseCircle size={28} />
                                          <Text marginTop={'4px'} fontSize={'13px'} width={'max-content'} fontWeight={'bold'}
                                          >
                                              Aguardando {acao.status === 1 ? 'aprovação' : 'alteração'}
                                          </Text>
                                      </Flex>
                                  )
                              }

                              {
                                  (acao.status === 8) && (
                                      <Flex alignItems={'center'} color='var(--Roxo)' flexDir={'column'}>
                                          <MdDirections size={28} />
                                          <Text marginTop={'4px'} fontSize={'13px'} width={'max-content'} fontWeight={'bold'}
                                          >
                                              Ação remanejada
                                          </Text>
                                      </Flex>
                                  )
                              }

                              {
                                  (acao.status === 5) && (
                                      <Flex alignItems={'center'} color='var(--Azul)' flexDir={'column'}>
                                          <FaSpinner size={28} />
                                          <Text marginTop={'4px'} fontSize={'13px'} width={'max-content'} fontWeight={'bold'}>Em andamento</Text>
                                      </Flex>
                                  )
                              }

                              {
                                  (acao.status === 7) && (
                                      <Flex alignItems={'center'} color='var(--Green2)' flexDir={'column'}>
                                          <FaCheckCircle size={28} />
                                          <Text marginTop={'4px'} fontSize={'13px'} width={'max-content'} fontWeight={'bold'}>Concluído</Text>
                                      </Flex>
                                  )
                              }

                              {
                                  (acao.status === 6) && (
                                      <Flex alignItems={'center'} color='var(--Red)' flexDir={'column'}>
                                          <FaClock size={28} />
                                          <Text marginTop={'4px'} fontSize={'13px'} width={'max-content'} fontWeight={'bold'}>Atrasada</Text>
                                      </Flex>
                                  )
                              }
                        </Flex>
                        <FormControl w={acao.status !== 0 ? '84%' : '100%'}>
                          <FormLabel fontSize={'14px'} mb={'.25rem'} fontWeight={'700'}>O que fazer?</FormLabel>
                          <PDIText>{acao.titulo}</PDIText>
                        </FormControl>

                        <Flex gap={'2%'} mt={'.5rem'}>
                          <FormControl>
                            <FormLabel fontSize={'14px'} mb={'.25rem'} fontWeight={'700'}>Como será realizada essa ação?</FormLabel>
                            <PDIText>{acao.descricao}</PDIText>
                          </FormControl>
                        </Flex>

                        {ReturnNotaPDI(acao.id, item.ultimoPDI?.avaliacoes)}

                        {acao.progresso && <Flex flexDir={'column'} gap={'1rem'} py={'.5rem'}>
                          <Divider borderColor={'var(--c6)'} opacity={'.8'}/>
                          <Flex gap={'1.5rem'}>
                            <Flex flex='1' p={'.5rem 1rem'} flexDir='column' justifyContent={'space-between'} fontSize='14px' bg={'var(--c2)'} border={'1px solid var(--c6)'} gap={'.75rem'}>
                              <span dangerouslySetInnerHTML={{ __html: FormatarMensagemEditorDeTexto(acao.progresso.comentario ?? '') }}></span>
                              <Text fontSize={'13px'}>Enviado por <strong>{acao.progresso.colaborador?.nome}</strong> no dia <strong>{acao.progresso.data}</strong> às <strong>{acao.progresso.hora}</strong></Text>
                            </Flex>
                            <Flex flexDir={'column'} alignItems={'center'} justifyContent={'center'} mb={'-.625rem'}>
                              <Text fontWeight={'700'}fontSize={'14px'}>Progresso realizado</Text>
                              <CircularProgress size={'3.5rem'} value={acao.progresso.progresso} color={GetColorProgresso(acao.progresso.progresso)}>
                                <CircularProgressLabel top={'43%'}>{acao.progresso.progresso}%</CircularProgressLabel>
                              </CircularProgress>
                            </Flex>
                          </Flex>
                        </Flex>}
                    </Flex>
                </Flex>
                })}
              </Grid>
            </Flex>
          }

          if (!ItensOpacosIds.includes(item.id)) {
            setItensOpacosIds([...ItensOpacosIds, item.id])
          }

          return <Flex justifyContent={'center'}>
          <ImgSah center textoPersonalizado='Não foi encontrado nenhum plano de desenvolvimento realizado por esse colaborador'></ImgSah>
        </Flex>

        case 6:
          if (item.historicoAvaliacoes) {
            if (item && ItensOpacosIds.includes(item?.id)) {
              if (item && ItensOpacosIds.includes(item?.id)) {
                setItensOpacosIds([...ItensOpacosIds.filter(e => e !== item?.id)])
              }
            }
            return <Flex flexDir={'column'} gap={'1rem'} w={'full'}>
              {item.historicoAvaliacoes?.length > 1 ? <h3>Histórico de pesquisas de desempenho</h3> : <></>}
              {item.historicoAvaliacoes.map(aval => {
                const response = <>
                <AccordionContainer title='Participantes' hideHr>
                  {GetParticipantesAvaliacao(aval, item.id)}
                  <Divider borderColor={'var(--c6)'} opacity={'.8'} mt={'1.5rem'} mb={'1rem'}/>
                </AccordionContainer>
                {aval.resultadoQuantitativa && <Flex flexDir={'column'} gap={'1rem'}>
                    {aval.resultadoQuantitativa?.recomendacoes.length > 0 && <>
                      <Titulo>Recomendações</Titulo>
                      <Grid templateColumns={`repeat(${aval.resultadoQuantitativa?.recomendacoes.length > 4 ? 4 : aval.resultadoQuantitativa?.recomendacoes.length}, 1fr)`} gap={'1rem'}>
                        {
                          aval.resultadoQuantitativa?.recomendacoes.map((e, i) => {
                            return (
                              <Recomendacao pos={i + 1} recomendacao={e} key={i} />
                            )
                          })
                        }
                      </Grid>
                      <Divider borderColor={'var(--c6)'} opacity={'.8'} my={'.5rem'}/>
                    </>}
                    <GridContainer>
                      {(!TabGrafico.find(e => e.avalId === aval?.id) || TabGrafico.find(e => e.avalId === aval?.id)?.tab === 0) && aval.resultadoQuantitativa.graficoHierarquia && (
                        <Flex flexDir={'column'} width='100%' h={'100%'}>
                          <Flex justifyContent={'space-between'} gap={'.5rem'}>
                            <Flex justifyContent={'space-between'} gap={'.35rem'} flex={'1'}>
                              <Flex gap={'.75rem'} flex={'1'}>
                                <Titulo>Gráfico de hierarquia</Titulo>
                              </Flex>
                              {(aval.resultadoQuantitativa.graficoHierarquia) && (
                                <SwitchCmp value={TabGrafico.find(e => e.avalId === aval?.id)?.tab === 1} OnChange={(e) => { OnChangeTabGrafico(aval?.id ?? '', 1) }} legendaDireita={'Gráfico individual'} legendaEsquerda={'Gráfico de hierarquia'}/>
                              )}
                            </Flex>
                          </Flex>
                          <LoadingContainer linhas={16} loading={IsLoadingIndividual} my={'1rem'}>
                            <Flex justifyContent={'center'} width='100%' position={'relative'}>
                              <Flex w={'34rem'}>
                                <RadarChartJs
                                  competencias={aval.resultadoQuantitativa?.graficoHierarquia.competencias ?? []}
                                  dados={aval.resultadoQuantitativa?.graficoHierarquia.dados ?? []}
                                  notaMinimaEscala={aval.resultadoQuantitativa.escala?.respostas.sort((a, b) => a.peso - b.peso)[1]?.peso}
                                  notaMaximaEscala={aval.resultadoQuantitativa.escala?.respostas.sort((a, b) => a.peso - b.peso)[aval.resultadoQuantitativa.escala?.respostas.length - 1]?.peso}
                                  stepSize={((aval.resultadoQuantitativa.escala?.respostas[0]?.peso ?? 0) - (aval.resultadoQuantitativa.escala?.respostas[1]?.peso ?? 0)) ?? 0}
                                />
                              </Flex>
                            </Flex>
                          </LoadingContainer>
                        </Flex>)
                      }

                      {TabGrafico.find(e => e.avalId === aval?.id)?.tab === 1 && aval.resultadoQuantitativa.graficoIndividual && (
                        <Flex flexDir={'column'} width='100%' h={'100%'}>
                          <Flex justifyContent={'space-between'}>
                              <Flex w={'full'} gap={'.5rem'}>
                                <Flex justifyContent={'space-between'} gap={'.35rem'} flex={'1'} w={'100%'}>
                                  <Flex gap={'.75rem'} flex={'1'}>
                                    <Titulo>Gráfico individual</Titulo>
                                  </Flex>
                                  {(aval.resultadoQuantitativa.graficoIndividual) && (
                                    <SwitchCmp value={TabGrafico.find(e => e.avalId === aval?.id)?.tab === 1} OnChange={(e) => { OnChangeTabGrafico(aval?.id ?? '', 0) }} legendaDireita={'Gráfico individual'} legendaEsquerda={'Gráfico de hierarquia'}/>
                                  )}
                                </Flex>
                              </Flex>
                          </Flex>
                          <LoadingContainer linhas={16} loading={IsLoadingIndividual} my={'1rem'}>
                            <Flex justifyContent={'center'} width='100%' position={'relative'}>
                              <Flex w={'34rem'}>
                                  <RadarChartJs
                                    competencias={aval.resultadoQuantitativa.graficoIndividual.competencias ?? []}
                                    dados={aval.resultadoQuantitativa.graficoIndividual.dados ?? []}
                                    notaMinimaEscala={aval.resultadoQuantitativa.escala?.respostas.sort((a, b) => a.peso - b.peso)[1]?.peso}
                                    notaMaximaEscala={aval.resultadoQuantitativa.escala?.respostas.sort((a, b) => a.peso - b.peso)[aval.resultadoQuantitativa.escala?.respostas.length - 1]?.peso}
                                    stepSize={((aval.resultadoQuantitativa.escala?.respostas[0]?.peso ?? 0) - (aval.resultadoQuantitativa.escala.respostas[1]?.peso ?? 0)) ?? 0}
                                  />
                              </Flex>
                            </Flex>
                          </LoadingContainer>
                        </Flex>)
                      }
                      <Divider height={Width < 1599 ? '' : '100%'} borderColor={'var(--c6)'} opacity={'.8'} orientation={Width < 1599 ? 'horizontal' : 'vertical'}/>
                      <Flex flexDir={'column'} gap={'1.5rem'} alignItems={'start'} h={'full'}>
                        <Titulo>Tabela dos resultados por hierarquia</Titulo>
                        <Tabela
                          cores={aval.resultadoQuantitativa.cores}
                          discursivas={aval.resultadoQuantitativa.discursivas}
                          linhas={aval.resultadoQuantitativa.tabela}
                          mediaGeral={aval.resultadoQuantitativa.mediaGeral}
                          recomendacoes={aval.resultadoQuantitativa.recomendacoes}
                          temColuna={(tipo) => TemColuna(tipo, aval.resultadoQuantitativa?.participantes ?? [])}
                          apenasAutoAvaliacao={aval.resultadoQuantitativa.apenasAutoAvaliacao}
                        />
                        <Flex mt={'.5rem'} flexWrap={'wrap'} columnGap={'.2rem'} fontSize={'12px'} fontWeight={'400'} justifyContent={'center'}>
                          {aval.resultadoQuantitativa.escala?.respostas.sort((a, b) => b.peso - a.peso).map((e, i) => {
                            return (<span key={i}>{e.resposta}{e.peso !== -1 && <strong style={{ marginLeft: '.2rem' }}>({e.peso})</strong>};</span>)
                          })}
                        </Flex>
                        <Flex justifyContent={'center'} gap={'1rem'} w={'100%'}>
                          <Flex alignItems={'center'} gap={'.25rem'} fontSize={'.85rem'}>
                            <Box w={'.65rem'} h={'.65rem'} bgColor={'var(--Orange)'}></Box>
                            Notas mais baixas
                          </Flex>
                          <Flex alignItems={'center'} gap={'.25rem'} fontSize={'.85rem'}>
                            <Box w={'.65rem'} h={'.65rem'} bgColor={'#00aa00'}></Box>
                            Notas mais altas
                          </Flex>
                        </Flex>
                      </Flex>
                    </GridContainer>
                  </Flex>}
                  {aval.resultadoIndicativa && <Flex flexDir={'column'} gap={'1rem'}>
                    <Grid alignItems={'center'} gridTemplateColumns={`${Width > 1599 ? '1fr 1rem 1fr' : '1fr'}`} gap={'1.5rem'} h={'100%'}>
                      {GetResumoCompetencias(aval.resultadoIndicativa.resumoCompetencias, 0)}
                      {Width > 1599 && <Divider height={'90%'} borderColor={'var(--c6)'} opacity={'.8'} orientation={'vertical'}/>}
                      {GetResumoCompetencias(aval.resultadoIndicativa.resumoCompetencias, 1)}
                      {GetResumoCompetencias(aval.resultadoIndicativa.resumoCompetencias, 2, Width > 1599)}
                      {Width > 1599 && <Divider height={'90%'} borderColor={'var(--c6)'} opacity={'.8'} orientation={'vertical'}/>}
                      {GetResumoCompetencias(aval.resultadoIndicativa.resumoCompetencias, 3, true)}
                    </Grid>
                    <Divider borderColor={'var(--c6)'} opacity={'.8'} mb={'.5rem'} orientation={'horizontal'}/>
                    <TabelaIndicativa modelo={aval.resultadoIndicativa}/>
                  </Flex>}
                </>
                if (item.historicoAvaliacoes?.length === 1) {
                  return <Flex flexDir={'column'} gap={'1rem'}>
                    <Flex justifyContent={'space-between'}>
                      <h3>{aval.nomePesquisa} - {aval.dataInicio} até {aval.dataFim}</h3>
                      {aval.encerrada && (((parseJwt().cid === Model?.participante.id && aval.liberarResultado === 0) ||
                      parseJwt().cid === Model?.responsavel.id) ||
                      parseJwt().role === '2' || parseJwt().adm === 'True') && <ButtonCmp VarColor='Green2' leftIcon={<BsGraphUp/>} onClick={() => nav(`/Desempenho/AnaliseDesempenho/${aval.resultadoQuantitativa ? 'Quantitativa' : 'Indicativa'}/ResultadoIndividual/${aval?.id}`)} isDisabled={item?.avaliacao?.avaliadores.filter(e => e.respondido).length === 0}>Visualizar resultados</ButtonCmp>}
                    </Flex>
                    {response}
                  </Flex>
                }
                return <AccordionContainer title={`${aval.nomePesquisa} - ${aval.dataInicio} até ${aval.dataFim}`}>
                  <Flex justifyContent={'end'}>
                    {aval.encerrada && (((parseJwt().cid === Model?.participante.id && aval.liberarResultado === 0) ||
                      parseJwt().cid === Model?.responsavel.id) ||
                      parseJwt().role === '2' || parseJwt().adm === 'True') && <ButtonCmp my={'1rem'} VarColor='Green2' leftIcon={<BsGraphUp/>} onClick={() => nav(`/Desempenho/AnaliseDesempenho/${aval.resultadoQuantitativa ? 'Quantitativa' : 'Indicativa'}/ResultadoIndividual/${aval?.id}`)} isDisabled={item?.avaliacao?.avaliadores.filter(e => e.respondido).length === 0}>Visualizar resultados</ButtonCmp>}
                  </Flex>
                  {response}
                </AccordionContainer>
              })}
            </Flex>
          }

          if (!ItensOpacosIds.includes(item.id)) {
            setItensOpacosIds([...ItensOpacosIds, item.id])
          }

          return <Flex justifyContent={'center'}>
          <ImgSah center textoPersonalizado='Esse colaborador não possui nenhuma avaliação com resultado liberado para visualização'></ImgSah>
        </Flex>

        case 7:
          if (item.ultimaAvaliacaoNineBox && item.nineBox) {
            if (item && ItensOpacosIds.includes(item?.id)) {
              if (item && ItensOpacosIds.includes(item?.id)) {
                setItensOpacosIds([...ItensOpacosIds.filter(e => e !== item?.id)])
              }
            }
            return <Flex flexDir={'column'} gap={'2rem'} w={'100%'}>
              <h3>Última calibração do 9Box encontrada deste colaborador</h3>
              <Grid gridTemplateColumns={(Width < 1599 && IsExpanded) ? '1fr' : '1fr 1rem 1fr'} gap={'2.5rem'} alignItems={(Width < 1599 && IsExpanded) ? 'center' : undefined} justifyContent={(Width < 1599 && IsExpanded) ? 'center' : undefined} mx={(Width < 1599 && IsExpanded) ? 'auto' : undefined}>
                <Flex flexDir={'column'} gap={'1rem'} alignItems={'center'} justifyContent={'center'}>
                  <Flex gap={'2rem'} pl={'13rem'}>
                    <Text fontSize={'14px'}>{item.nineBox.configuracaoEixoY.titulo}: <strong>{item.ultimaAvaliacaoNineBox.notaY.toFixed(2)}</strong></Text>
                    <Text fontSize={'14px'}>{item.nineBox.configuracaoEixoX.titulo}: <strong>{item.ultimaAvaliacaoNineBox.notaX.toFixed(2)}</strong></Text>
                  </Flex>
                  <NineBox
                    avaliacao={item.ultimaAvaliacaoNineBox}
                    model={item.nineBox}
                  />
                </Flex>
                <Divider orientation={(Width < 1599 && IsExpanded) ? 'horizontal' : 'vertical'} h={(Width < 1599 && IsExpanded) ? undefined : '42rem'} opacity={'.9'} borderColor={'var(--c4)'}/>
                <Flex flexDir={'column'} gap={'1rem'} w={'100%'}>
                  <Text fontWeight={700}>Comitês realizados</Text>
                  {item.ultimaAvaliacaoNineBox.comites?.slice(0, 3).map((r, i) => {
                    return (
                      <Flex flexDir={'column'} borderRadius={'.25rem'} border={'1px solid var(--c4)'} bg={'var(--AzulOpacoBg)'} padding='1rem' key={i}>
                        <Flex justifyContent={'space-between'} alignItems={'center'}>
                          <Box>
                            {r.responsavel && <Text fontWeight={'bold'} fontSize={'0.813rem'}>Alterado por {r.responsavel.nome} em {r.dataAvaliacao}</Text>}
                            {PropInvalida(r.avaliacaoAnterior) && (
                              <Text
                                fontWeight={'bold'}
                                fontSize={'0.813rem'}
                              >Avaliou no quadrante {r.avaliacaoAtual}
                              </Text>
                            )}

                            {(!PropInvalida(r.avaliacaoAnterior) && (r.avaliacaoAnterior !== r.avaliacaoAtual)) &&
                              <Text
                                fontWeight={'bold'}
                                fontSize={'0.813rem'}
                              >Alterou de {r.avaliacaoAnterior} para {r.avaliacaoAtual}
                              </Text>
                            }

                            {((r.notaAnteriorX !== null && r.notaAnteriorX !== -1) && (r.notaNovaX !== -1) && (r.notaNovaX !== r.notaAnteriorX)) &&
                              <Text
                                fontWeight={'bold'}
                                fontSize={'0.813rem'}
                              >Alterou de {r.notaAnteriorX?.toFixed(1)} para {r.notaNovaX?.toFixed(1)} no eixo de {item.nineBox?.configuracaoEixoX.titulo}
                              </Text>
                            }
                            {((r.notaAnteriorX !== null && (r.notaAnteriorX === -1)) && (r.notaNovaX !== -1)) &&
                              <Text
                                fontWeight={'bold'}
                                fontSize={'0.813rem'}
                              >Atribuiu {r.notaNovaX?.toFixed(1)} como a primeira nota no eixo de {item.nineBox?.configuracaoEixoX.titulo}
                              </Text>
                            }

                            {((r.notaAnteriorY !== null && r.notaAnteriorY !== -1) && (r.notaNovaY !== -1) && (r.notaNovaY !== r.notaAnteriorY)) &&
                              <Text
                                fontWeight={'bold'}
                                fontSize={'0.813rem'}
                              >Alterou de {r.notaAnteriorY?.toFixed(1)} para {r.notaNovaY?.toFixed(1)} no eixo de {item.nineBox?.configuracaoEixoY.titulo}
                              </Text>
                            }
                            {((r.notaAnteriorY !== null && (r.notaAnteriorY === -1)) && (r.notaNovaY !== -1)) &&
                              <Text
                                fontWeight={'bold'}
                                fontSize={'0.813rem'}
                              >Atribuiu {r.notaNovaY?.toFixed(1)} como a primeira nota no eixo de {item.nineBox?.configuracaoEixoY.titulo}
                              </Text>
                            }
                          </Box>
                        </Flex>
                        {r.comentario && <Flex flexDir={'column'} mt={'.5rem'} padding={'.5rem 1rem'} bg='var(--c1)' border={'1px solid var(--AzulOpaco)'}>
                          <Text fontWeight={'700'} fontSize={'0.8135rem'}>Comentário</Text>
                          <Text fontSize={'0.875rem'}>{r.comentario}</Text>
                        </Flex>}

                        <Text my={'.5rem'} fontSize={'1.125rem'} fontWeight={'700'}>Comitê que realizou a calibração</Text>
                        <Flex gap={'2rem'}>
                          {r.comite.map((c, i2) => {
                            return (
                              <Flex gap={'.325rem'} key={i2} alignItems={'center'}>
                                <Avatar size={'sm'} src={c.avatar} name={c.nome} />
                                <Flex flexDir={'column'}>
                                  <Text fontSize={'.875rem'} fontWeight={'700'} lineHeight={'1.125rem'}>{c.nome}</Text>
                                  <Text fontSize={'.875rem'} lineHeight={'.925rem'}>{c.complemento}</Text>
                                </Flex>
                              </Flex>
                            )
                          })}
                        </Flex>
                      </Flex>
                    )
                  })}
                  {item.ultimaAvaliacaoNineBox.comites?.length === 0 && <Flex fontWeight={700} fontSize={'14px'}>Não foi encontrado nenhum comitê</Flex>}
                </Flex>
              </Grid>
            </Flex>
          }

          if (!ItensOpacosIds.includes(item.id)) {
            setItensOpacosIds([...ItensOpacosIds, item.id])
          }

          return <Flex justifyContent={'center'}>
          <ImgSah center textoPersonalizado='Não foi encontrado nenhuma calibração desse colaborador'></ImgSah>
        </Flex>

        case 8:
          if (item.ultimasReunioes) {
            if (item && ItensOpacosIds.includes(item?.id)) {
              if (item && ItensOpacosIds.includes(item?.id)) {
                setItensOpacosIds([...ItensOpacosIds.filter(e => e !== item?.id)])
              }
            }
            return <Flex flexDir={'column'} width={'100%'}>
              <Flex flexDir={'column'}>
                <h3>Histórico de Reuniões 1:1 do colaborador</h3>
                <Text fontSize={'14px'} fontWeight={400} color={'var(--Gray2)'}>Para visualizar mais detalhes das reuniões, clique na linha do item que deseja ver mais detalhes</Text>
              </Flex>
              <TabelaReunioes
                reunioes={item.ultimasReunioes}
              />
            </Flex>
          }

          if (!ItensOpacosIds.includes(item.id)) {
            setItensOpacosIds([...ItensOpacosIds, item.id])
          }

          return <Flex justifyContent={'center'}>
          <ImgSah center textoPersonalizado='Não foi encontrado nenhuma Reunião 1:1 com o colaborador'></ImgSah>
        </Flex>

        case 9:
          if (item.processosRealizados) {
            if (item && ItensOpacosIds.includes(item?.id)) {
              if (item && ItensOpacosIds.includes(item?.id)) {
                setItensOpacosIds([...ItensOpacosIds.filter(e => e !== item?.id)])
              }
            }
            return <Flex flexDir={'column'} width={'100%'}>
              <Flex flexDir={'column'}>
                <h3 style={{ marginBottom: '1rem' }}>Últimos processos de onboarding realizados pelo colaborador</h3>
                <SectionOnboard>
                  {
                    item.processosRealizados?.map((e, i) => {
                      return (
                        <CardOnboard
                          key={i}
                          processo={e}
                        />
                      )
                    })
                  }
                </SectionOnboard>
              </Flex>
            </Flex>
          }

          if (!ItensOpacosIds.includes(item.id)) {
            setItensOpacosIds([...ItensOpacosIds, item.id])
          }

          return <Flex justifyContent={'center'}>
          <ImgSah center textoPersonalizado='Não foi encontrado nenhum processo de onboarding'></ImgSah>
        </Flex>

        case 10:
          if (item.resultadosIndividuais) {
            if (item && ItensOpacosIds.includes(item?.id)) {
              if (item && ItensOpacosIds.includes(item?.id)) {
                setItensOpacosIds([...ItensOpacosIds.filter(e => e !== item?.id)])
              }
            }
            return (
              <Flex flexDir={'column'} gap={'1rem'} w={'100%'}>
                <h3>Histórico de pesquisas internas do participante</h3>
                <Flex justifyContent={'space-between'} borderBottom={'1px solid var(--Azul)'} pb={'1rem'} alignItems={'center'}>
                  <Flex flexDir={'column'}>
                    <Text fontSize={'1rem'}>Pesquisa: <strong>{item.resultadosIndividuais[SelectedIndividual - 1].respondente}</strong></Text>
                    <Text fontSize={'14px'} fontWeight={400} color={'var(--Gray3)'}>Data de preenchimento: <strong>{item.resultadosIndividuais[SelectedIndividual - 1].respondido ?? 'Não preenchido'}</strong></Text>
                  </Flex>
                  <HStack mt={0} p={'.25rem'} fontSize={'.875rem'}>
                    <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => PrevPage(item.resultadosIndividuais?.length ?? 0)} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                    <Text>{numberFormatter.format(SelectedIndividual)} / {item.resultadosIndividuais.length}</Text>
                    <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => NextPage(item.resultadosIndividuais?.length ?? 0)} VarColor='Green2'><FaArrowRight/></ButtonCmp>
                  </HStack>
                </Flex>
                <Flex flexDir={'column'}>
                  {
                    item.resultadosIndividuais[SelectedIndividual - 1]?.respostas.map((e, i) => {
                      if (e.tipo === 0) {
                        return (
                          <MultiplaEscolha
                            key={i}
                            questao={e}
                          />
                        )
                      } else if (e.tipo === 5) {
                        return (
                          <CaixaDeSelecao
                            key={i}
                            questao={e}
                          />
                        )
                      } else if (e.tipo === 1) {
                        return (
                          <Discursiva
                            key={i}
                            questao={e}
                          />
                        )
                      } else if (e.tipo === 6) {
                        return (
                          <Escala
                            key={i}
                            questao={e}
                          />
                        )
                      }
                      return null
                    })
                  }
                </Flex>
              </Flex>
            )
          }

          if (!ItensOpacosIds.includes(item.id)) {
            setItensOpacosIds([...ItensOpacosIds, item.id])
          }

          return <Flex justifyContent={'center'}>
          <ImgSah center textoPersonalizado='Não foi encontrada nenhuma pesquisa que este participante respondeu'></ImgSah>
        </Flex>

        case 5:
        case 15:
          if (item.formulario) {
            if (item.formulario.resultado) {
              return (
                <Flex flexDir={'column'} gap={'1rem'} w={'100%'}>
                  <Flex justifyContent={'space-between'} alignItems={'center'}>
                    <h3>Resultados do formulário: {item.formulario.nome}</h3>
                    <Flex gap={'.75rem'}>
                      {IsGestorOrADM() && item.resultadoLiberado === true && <ButtonCmp
                        borderRadius={'.5rem'}
                        VarColor='Rosa'
                        leftIcon={<FaEyeSlash />}
                        onClick={() => AlterarVisibiliadeInterna(item.id, false)}
                      >
                        Ocultar resultado do gestor
                      </ButtonCmp>}
                      {IsGestorOrADM() && item.resultadoLiberado === false && <ButtonCmp
                        leftIcon={<FaEye />}
                        borderRadius={'.5rem'}
                        VarColor='Rosa'
                        onClick={() => AlterarVisibiliadeInterna(item.id, true)}
                      >
                        Liberar resultado do gestor
                      </ButtonCmp>}
                      {!Model?.dashboard.concluido && item.formulario.resultado.questoes && item.formulario.resultado.minhasRespostas && <ButtonCmp leftIcon={ModoEdicao.find(e => e.pesquisaId === item.formulario?.pesquisaId)?.ativo ? <FaEye/> : <FaPencilAlt/>} VarColor={'Rosa'} onClick={() => OnChangeModoEdicao(item.formulario?.pesquisaId)}>
                        {ModoEdicao.some(e => e.pesquisaId === item.formulario?.pesquisaId) ? 'Modo de visualização' : 'Modo de edição'}
                      </ButtonCmp>}
                    </Flex>
                  </Flex>
                  <Flex gap={'1.5rem'}>
                    {item.formulario.resultado.participante && <Flex flexDir={'column'} gap={'.25rem'}>
                      <Text fontWeight={600} fontSize={'16px'}>Participante</Text>
                      <Flex gap={'.75rem'} alignItems={'center'} border={'1px solid var(--c6)'} px={'1rem'} py={'.75rem'} borderRadius={'.25rem'}>
                        <Avatar src={item.formulario.resultado.participante.avatar} size={'sm'}/>
                        <Flex flexDir={'column'} gap={'.25rem'} lineHeight={'14px'}>
                          <Text fontSize={'14px'}>Nome: <strong>{item.formulario.resultado.participante.nome}</strong></Text>
                          <Text fontSize={'13px'} fontWeight={400} color={'var(--Gray3)'}>Data de preenchimento: <strong>{item.formulario.resultado.participante.complemento ?? 'Não preenchido'}</strong></Text>
                        </Flex>
                      </Flex>
                    </Flex>}
                    {item.formulario.resultado.responsavel && <Flex flexDir={'column'} gap={'.25rem'}>
                      <Text fontWeight={600} fontSize={'16px'}>Responsável</Text>
                      <Flex gap={'.75rem'} alignItems={'center'} border={'1px solid var(--c6)'} px={'1rem'} py={'.75rem'} borderRadius={'.25rem'}>
                        <Avatar src={item.formulario.resultado.responsavel.avatar} size={'sm'}/>
                        <Flex flexDir={'column'} gap={'.25rem'} lineHeight={'14px'}>
                          <Text fontSize={'14px'}>Nome: <strong>{item.formulario.resultado.responsavel.nome}</strong></Text>
                          <Text fontSize={'13px'} fontWeight={400} color={'var(--Gray3)'}>Data de preenchimento: <strong>{item.formulario.resultado.responsavel.complemento ?? 'Não preenchido'}</strong></Text>
                        </Flex>
                      </Flex>
                    </Flex>}
                  </Flex>
                  <Flex flexDir={'column'}>
                    {!ModoEdicao.find(e => e.pesquisaId === item.formulario?.pesquisaId)?.ativo && <Flex flexDir={'column'} gap={'1rem'}>
                      {GroupBy(item.formulario.resultado.respostas, (item) => item.id).toList().map(r => {
                        return (
                          <Flex key={r.key} flexDirection={'column'} my={'1rem'}>
                            <Text fontSize={'16px'} fontWeight={600} mb={'.75rem'}>• {r.data[0].enunciado}</Text>
                            {r.data.map((questao, i) => {
                              return (
                                <Flex flexDirection={'column'}>
                                {(questao.tipo === 0 || questao.tipo === 6) &&
                                  <QuestaoAlternativa
                                    questao={questao}
                                  />
                                }
                                {questao.tipo === 5 &&
                                  <QuestaoCaixaSelecao
                                    questao={questao}
                                  />
                                }
                                {questao.tipo === 1 &&
                                  <QuestaoComentario
                                    questao={questao}
                                    respondente={questao.alternativaResposta.some(r => r.avatares.includes(item.formulario?.resultado?.participante.avatar ?? '')) ? item.formulario?.resultado?.participante : item.formulario?.resultado?.responsavel}
                                  />
                                }
                              </Flex>
                              )
                            })}
                          </Flex>)
                      })}
                      {item.comentarios && <AccordionContainer title='Comentários de edição'>
                        <Flex flexDir={'column'} gap={'1.5rem'} mt={'1rem'}>
                          {item?.comentarios?.map(e => {
                            return <Flex px={'1.25rem'} py={'.75rem'} border={'1px solid var(--c6)'} borderRadius={'.25rem'} bg={'var(--c2)'} fontSize={'14px'} gap={'.75rem'} flexDir={'column'}>
                              {e.colaborador && <Flex gap={'.5rem'} alignItems={'center'}>
                                <Avatar src={e.colaborador.avatar} size={'xs'}/>
                                <Text fontWeight={600}>{e.colaborador.nome}</Text>
                              </Flex>}
                              <Text fontWeight={400}>{e.texto}</Text>
                              <Text fontWeight={600} color={'var(--Gray3)'}>{e.data}</Text>
                            </Flex>
                          })}
                        </Flex>
                      </AccordionContainer>}
                    </Flex>}
                    {item.formulario.resultado.questoes && ModoEdicao.find(e => e.pesquisaId === item.formulario?.pesquisaId)?.ativo && <Flex flexDir={'column'}>
                      {
                        item.formulario.resultado.questoes?.map((e: iFormPreenchimentoQuestaoResponse, i) => {
                          if (e.tipo === 0) {
                            return (
                              <MultiplaEscolhaPreenchimento
                                key={i}
                                questao={e}
                                isSelect={(perguntaId, alternativaId) => GetIsSelect(perguntaId, item).includes(alternativaId)}
                                SelecionarQuestao={(perguntaId, alternativaId) => onUpdateResposta(item, index ?? 0, perguntaId, alternativaId)}
                                erro={false}
                              />
                            )
                          } else if (e.tipo === 5) {
                            return (
                              <CaixaDeSelecaoPreenchimento
                                key={i}
                                selecionadas={GetIsSelect(e.id, item)}
                                questao={e}
                                Selecionar={(questaoId, alternativaId) => onUpdateResposta(item, index ?? 0, questaoId, alternativaId, undefined, e.tipo)}
                                erro={false}
                              />
                            )
                          } else if (e.tipo === 1) {
                            return (
                              <DiscursivaPreenchimento
                                key={e.id}
                                questao={e}
                                erro={false}
                                UpdateText={(perguntaId, texto) => onUpdateResposta(item, index ?? 0, perguntaId, undefined, texto)}
                              />
                            )
                          } else if (e.tipo === 6) {
                            return (
                              <EscalaPreenchimento
                                key={i}
                                questao={e}
                                isSelect={(perguntaId, alternativaId) => GetIsSelect(perguntaId, item).includes(alternativaId)}
                                SelecionarQuestao={(questaoId, alternativaId) => onUpdateResposta(item, index ?? 0, questaoId, alternativaId)}
                                erro={false}
                              />
                            )
                          }
                          return null
                        })
                      }
                      <Flex flexDir={'column'} gap={'1rem'}>
                        <TextAreaCmp value={ComentarioItem.find(e => e.id === item.id)?.texto ?? ''} OnChange={(val) => OnUpdateComentarioTexto(val, item.id)} label={'Comentários'}/>
                        {item?.formulario?.resultado?.minhasRespostas && <ButtonCmp w={'12rem'} alignSelf={'center'} VarColor='Green2' onClick={() => onUpdateRespostasFormulario(item.id, item.formulario?.pesquisaId ?? '', item.formulario?.resultado?.minhasRespostas ?? [])} leftIcon={<FaSave/>}>Salvar alterações</ButtonCmp>}
                      </Flex>
                    </Flex>}
                  </Flex>
                </Flex>)
            } else {
              return <Flex flexDir={'column'} gap={'2rem'} w={'full'}>
                <Flex justifyContent={'space-between'}>
                  <Flex flexDir={'column'} gap={'.125rem'}>
                    <h3>{item.formulario.nome}</h3>
                    <Flex gap={'.75rem'} fontSize={'.875rem'} color={'var(--Gray3)'} fontWeight={'400'}>
                      <Text>Data de início: <strong>{item.formulario.dataInicio}</strong></Text>
                      <Text fontWeight={700}>-</Text>
                      <Text>Data de término: <strong>{item.formulario.dataFim}</strong></Text>
                    </Flex>
                  </Flex>
                  <Flex gap={'1rem'}>
                    {!item.formulario.respondido && item.formulario.extenderPrazo && parseJwt().adm === 'True' && <ButtonCmp VarColor='Green2' leftIcon={<FaCalendar/>} onClick={() => setDataFimUpdate({ dataFim: item.formulario?.dataFim ?? '', itemId: item.id })}>Extender prazo de preenchimento</ButtonCmp>}
                    {!item.formulario.respondido && item.formulario.iniciarAntes && IsGestorOrADM() && <ButtonCmp VarColor='Green2' leftIcon={<FaCalendar/>} onClick={() => AdiantarItem(item.id)}>Iniciar item agora</ButtonCmp>}
                    {!item.formulario.respondido && !item.formulario.iniciarAntes && IsGestorOrADM() && <ButtonCmp VarColor='Rosa' leftIcon={<FiMail/>} onClick={() => ReenviarConvitesPesquisaInterna(item.id, item.formulario?.pesquisaId ?? '')}>Reenviar convite para preenchimento</ButtonCmp>}
                  </Flex>
                </Flex>
                <Flex maxW={'52rem'} justifyContent={'center'} mx={'auto'}>
                  <ImgSah masc center textoPersonalizado={item.formulario.iniciarAntes ? 'Esse formulário ainda não está disponível para preenchimento, aguarde até o dia da data de início' : (item.formulario.isParticipante && !item.formulario.respondido) ? 'O formulário ainda não foi preenchido, clique no botão abaixo para ser redirecionado para a tela de resposta' : 'Outro participante deste feedback ainda não respondeu esse formulário, por favor aguarde até que ele seja preenchido para visualizar os resultados'}>
                    {(item.formulario.isParticipante && !item.formulario.respondido) && !item.formulario.iniciarAntes && <ButtonCmp VarColor='Green2' big onClick={() => nav(`/PI/Abertura/${item.formulario?.conviteId}`)}>Responder formulário</ButtonCmp>}
                  </ImgSah>
                </Flex>
              </Flex>
            }
          }

          return <Flex fontWeight={700} fontSize={'18px'}>Não foi encontrado o convite deste participante, por favor contate o suporte do SAH</Flex>

        case 13:
          if (item.avaliacao && !CalibracaoEmAndamento.find(e => e.id === item.id)) {
            return ReturnItensAvaliacao(item, index ?? 0)
          } else if (!(CalibracaoEmAndamento.find(e => e.id === item.id) && item.calibracao) && parseJwt().cid === Model?.participante.id) {
            return <ImgSah masc center textoPersonalizado={'A calibração ainda não foi realizada. Os resultados serão disponibilizados assim que o gestor concluí-la.'}></ImgSah>
          } else if (CalibracaoEmAndamento.find(e => e.id === item.id) && item.calibracao) {
            return (
              <Flex bg={'var(--c1)'} w={'100%'} flexDir={'column'} p={'1rem 1.5rem'} gap={'1rem'}>
                <Flex justifyContent={'space-between'} alignItems={'start'}>
                  <Flex gap={'2rem'} fontSize={'14px'}>
                    <Flex alignItems={'center'} gap={'.5rem'} p={'.75rem 1.25rem'} borderRadius={'.25rem'} border={'1px solid var(--c5)'}>
                      <Avatar name={item.calibracao?.questoes[0]?.respostaGestor.colaborador.nome} src={item.calibracao?.questoes[0]?.respostaGestor.colaborador.avatar} size={'sm'}/>
                      <Text>Gestor: <strong>{item.calibracao?.questoes[0]?.respostaGestor.colaborador.nome}</strong></Text>
                    </Flex>

                    <Flex alignItems={'center'} gap={'.5rem'} p={'.75rem 1.25rem'} borderRadius={'.25rem'} border={'1px solid var(--c5)'}>
                      <Avatar name={item.calibracao?.questoes[0].respostaColaborador.colaborador.nome} src={item.calibracao?.questoes[0].respostaColaborador.colaborador.avatar} size={'sm'}/>
                      <Text>Avaliado: <strong>{item.calibracao?.questoes[0].respostaColaborador.colaborador.nome}</strong></Text>
                    </Flex>
                  </Flex>
                  {item.avaliacao && <ButtonCmp VarColor='c6' onClick={() => setCalibracaoEmAndamento([])}>{IsGestorOrADM() ? 'Cancelar alterações' : 'Voltar'}</ButtonCmp>}
                </Flex>
                <Divider borderColor={'var(--Azul)'} mt={'1.25rem'} mb={'.5rem'}/>
                <Flex gap={'1.5rem'} flexDir='column'>
                  <Flex flexDir={'column'} gap={'.325rem'}>
                    <h3>Calibração da pesquisa</h3>
                    <Text fontSize={'14px'} fontWeight={'400'} color={'var(--Gray2)'}>Na tabela abaixo, você encontrará as competências apresentadas na pesquisa, e ao lado, o ícone do avatar do respondente estará na coluna correspondente à sua resposta. Neste momento do feedback, é de extrema importância que vocês comparem suas respostas, discutam os pontos de discordância e atribuam uma nota de calibração.</Text>
                  </Flex>
                  <TabelaCalibracao
                    calibracao={item.calibracao}
                    itemId={item.id}
                    onChangeCalibracao={(itemId, calibracao) => { if (IsGestorOrADM()) { onChangeCalibracao(itemId, calibracao) } }}
                  />
                </Flex>
                <Flex w={'100%'} mt={'.5rem'}>
                  {item.calibracao?.tabela && <Tabela
                    cores={[]}
                    discursivas={[]}
                    recomendacoes={[]}
                    mediaGeral={0}
                    temColuna={(tipo) => TemColuna(tipo, item.calibracao?.participantes ?? [])}
                    linhas={item.calibracao?.tabela.sort((a, b) => { return a.competencia.localeCompare(b.competencia) })}
                    apenasAutoAvaliacao={false}
                  />}
                </Flex>
                <Flex justifyContent={'center'} margin={'1rem 0rem'}>
                  {IsGestorOrADM() && item.calibracao && <ButtonCmp
                    isLoading={IsLoading}
                    onClick={() => OnSendCalibracao(item.id, item.avaliacaoCalibracaoId ?? '', item.calibracao)}
                    size='lg'
                    VarColor='Green2'
                  >Enviar resposta</ButtonCmp>}
                  {!(IsGestorOrADM() && item.calibracao) && <ButtonCmp
                    isLoading={IsLoading}
                    onClick={() => setCalibracaoEmAndamento([])}
                    size='lg'
                    VarColor='c6'
                  >Voltar</ButtonCmp>}
                </Flex>
              </Flex>
            )
          } else if (item.iniciarAntes) {
            return (<ImgSah masc center textoPersonalizado={'O item tem início no dia ' + item.iniciarAntes + '. Clique no botão para iniciar agora o processo de calibração'}>
            {<ButtonCmp VarColor='Green2' big onClick={() => AdiantarItem(item.id, index)}>Iniciar antes</ButtonCmp>}
          </ImgSah>)
          }
          return <ImgSah masc center textoPersonalizado={'A pesquisa 90º ainda não foi encerrada, aguarde para que possa ser realizada a calibração'}></ImgSah>

        case 11:
          if (item.realizarReuniaoOne) {
            return (
              <RealizarReuniaoOne tipo={item.tipo} AdiantarItem={() => AdiantarItem(item.id)} Carregar={() => onGetItemById(item.id)} model={item.realizarReuniaoOne} OnRealizarCalibracao={() => OnRealizarCalibracao(item, index ?? 0)}/>
            )
          }

          return <Flex fontWeight={700} fontSize={'18px'}>Não foi encontrada a reunião 1:1 deste participante, por favor contate o suporte do SAH</Flex>

        case 12:
          if (item.calibrarNineBox) {
            const Periodo = PeriodoSelecionado.find(e => e.id === item.id)?.val ?? 0
            const calibracao = item.calibrarNineBox.calibracao
            return <Flex flexDir={'column'} w={'full'} gap={'1.25rem'}>
              <Flex justifyContent={'space-between'}>
                <Flex flexDir={'column'}>
                  <h3>{calibracao ? <>Colaborador calibrado no quadrante <Box as='span' color={'var(--Azul)'}>{calibracao.nomeQuadrante}</Box> ({item.calibrarNineBox.nineBox.configuracaoEixoY.titulo}: <Box as='span' color={'var(--Azul)'}>{calibracao.notaY.toFixed(1)}</Box>; {item.calibrarNineBox.nineBox.configuracaoEixoX.titulo}: <Box as='span' color={'var(--Azul)'}>{calibracao.notaX.toFixed(1)}</Box>)</> : item.status !== 1 ? 'Calibração pendente' : 'Item aguardando início'}</h3>
                  {calibracao && <Text fontSize={'14px'} color={'var(--c6)'} fontWeight={600}>Realizado em {calibracao?.dataCalibracao}</Text>}
                </Flex>
                {item.status === 1 && IsGestorOrADM() && <ButtonCmp VarColor='Green2' leftIcon={<FaCalendar/>} onClick={() => AdiantarItem(item.id)}>Iniciar item agora</ButtonCmp>}
              </Flex>
              <Flex gap={'1rem'} px={'1rem'} py={'.5rem'} w={'full'} flexDir='column'>
                {(item.calibrarNineBox.avaliacao || item.calibrarNineBox.indicador || item.calibrarNineBox.pdi) && <>
                  <Container maxW={'100%'}>
                    <Accordion allowToggle w={'full'}>
                      {item.calibrarNineBox.avaliacao && <AccordionItem>
                        <AccordionButton _focus={{ boxShadow: 'none !important' }} bg={'var(--c1)'} color={'var(--Azul)'} gap={'.3rem'} mt={'.5rem'} px={'0'} borderBottom={'1px solid var(--Azul)'}>
                          <Flex as='span' textAlign={'left'} fontSize={'0.875rem'} gap={'.2rem'}>
                            Pesquisa de desempenho - {item.calibrarNineBox.avaliacao?.nomePesquisa}
                            <AccordionIcon />
                          </Flex>
                        </AccordionButton>
                        <AccordionPanel py={'0.25rem'} px={'0.75rem'} display={'flex'} flexDir='column' gap={'.75rem'}>
                          <Flex flexDir={'column'} gap={'.5rem'} pb={'1.25rem'} borderBottom={'1px solid var(--AzulOpaco)'}>
                            <Text fontSize={'14px'} fontWeight={600}>Tabela dos resultados por hierarquia</Text>
                            <Tabela
                              cores={item.calibrarNineBox.avaliacao.cores}
                              discursivas={item.calibrarNineBox.avaliacao.discursivas}
                              linhas={item.calibrarNineBox.avaliacao.tabela}
                              mediaGeral={item.calibrarNineBox.avaliacao.mediaGeral}
                              recomendacoes={item.calibrarNineBox.avaliacao.recomendacoes}
                              temColuna={(tipo) => TemColuna(tipo, item.calibrarNineBox?.avaliacao?.participantes ?? [])}
                              apenasAutoAvaliacao={item.calibrarNineBox.avaliacao.apenasAutoAvaliacao}
                            />
                          </Flex>
                          <Flex flexDir={'column'} gap={'.5rem'}>
                            <Text fontSize={'14px'} fontWeight={600}>Gráfico de hierarquia</Text>
                            <RadarChartJs
                              competencias={item.calibrarNineBox.avaliacao?.graficoHierarquia?.competencias ?? []}
                              dados={item.calibrarNineBox.avaliacao?.graficoHierarquia?.dados ?? []}
                              notaMinimaEscala={0}
                              notaMaximaEscala={item.calibrarNineBox.avaliacao.escala?.respostas[item.calibrarNineBox.avaliacao.escala?.respostas.length]?.peso}
                              stepSize={((item.calibrarNineBox.avaliacao.escala?.respostas[0]?.peso ?? 0) - (item.calibrarNineBox.avaliacao.escala?.respostas[1]?.peso ?? 0)) ?? 0}
                            />
                          </Flex>
                        </AccordionPanel>
                      </AccordionItem>}
                      {item.calibrarNineBox.indicador && <AccordionItem>
                        <AccordionButton _focus={{ boxShadow: 'none !important' }} bg={'var(--c1)'} color={'var(--Azul)'} gap={'.3rem'} mt={'.5rem'} px={'0'} borderBottom={'1px solid var(--Azul)'}>
                          <Flex as='span' textAlign={'left'} fontSize={'0.875rem'} gap={'.2rem'}>
                            Indicador - {item.calibrarNineBox.indicador.nome}
                            <AccordionIcon />
                          </Flex>
                        </AccordionButton>
                        <AccordionPanel py={'0.25rem'} px={'0.75rem'} display={'flex'} flexDir='column' gap={'1.25rem'}>
                          <Flex flexDir={'column'} gap={'.75rem'}>
                            <HStack mt={'1rem'} fontSize={'.875rem'}>
                              <Text>Ano:</Text>
                              <Text>{item.calibrarNineBox.indicador.periodos[Periodo].ano}</Text>
                              {item.calibrarNineBox.indicador.periodos.length > 1 && <><ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => { PrevPagePeriodo(item, Periodo) }} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                              <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => { NextPagePeriodo(item, Periodo) }} VarColor='Green2'><FaArrowRight/></ButtonCmp></>}
                            </HStack>
                            <TabelaIndicador
                              status={item.calibrarNineBox.indicador.status}
                              tipo={item.calibrarNineBox.indicador.tipoMeta}
                              periodo={item.calibrarNineBox.indicador.periodos[Periodo]}
                              isResponsavel={item.calibrarNineBox.indicador.isResponsavel}
                            />
                          </Flex>
                          <IndicadorChart
                            indicador={item.calibrarNineBox.indicador}
                            data={item.calibrarNineBox.indicador.periodos[Periodo]?.meses}
                            id={'indicador-chart' + '-' + `${item.calibrarNineBox.indicador.id}-modal-ninebox`}
                          />
                        </AccordionPanel>
                      </AccordionItem>}
                      {item.calibrarNineBox.pdi && <AccordionItem>
                        <AccordionButton _focus={{ boxShadow: 'none !important' }} bg={'var(--c1)'} color={'var(--Azul)'} gap={'.3rem'} mt={'.5rem'} px={'0'} borderBottom={'1px solid var(--Azul)'}>
                          <Flex as='span' textAlign={'left'} fontSize={'0.875rem'} gap={'.2rem'}>
                            Último PDI do colaborador - {item.calibrarNineBox.pdi.acoes.length} Ações trabalhadas
                            <AccordionIcon />
                          </Flex>
                        </AccordionButton>
                        <AccordionPanel py={'0.25rem'} px={'0.75rem'} display={'flex'} flexDir='column' gap={'.75rem'}>
                          <Flex flexDir={'column'} marginTop='1rem' gap={'.75rem'}>
                            <Text fontSize={'.875rem'} fontWeight={600}>Ações do PDI</Text>
                            <Grid gap={'1.325rem'} templateColumns='repeat(1, 1fr)' overflowX={'hidden'}>
                              {
                                item.calibrarNineBox.pdi.acoes.map((a, i2) => {
                                  return (
                                    <AcaoCard
                                      key={i2}
                                      acao={a}
                                    />
                                  )
                                })
                              }
                            </Grid>
                          </Flex>
                        </AccordionPanel>
                      </AccordionItem>}
                    </Accordion>
                  </Container>
                  <Flex minW={'100%'} h={'2px'} bg={'var(--c6)'} my={'1.25rem'}></Flex>
                </>}
                <Flex minW={(item.calibrarNineBox.avaliacao || item.calibrarNineBox.indicador || item.calibrarNineBox.pdi) ? '50%' : '100%'} pr={'1rem'} flexDir={'column'} alignItems={!(item.calibrarNineBox.avaliacao || item.calibrarNineBox.indicador || item.calibrarNineBox.pdi) ? 'center' : undefined}>
                  <Flex mb={'2rem'} gap={'1.25rem'} pl={'1.5rem'}>
                      <Flex flexDirection={'column'}>
                        <Box mb={'.15rem'} fontSize={'.875rem'} fontWeight={'700'}>
                          {item.calibrarNineBox.nineBox.configuracaoEixoY.titulo}
                        </Box>
                        <NumberInput
                          isInvalid={item.calibrarNineBox.notaYInconentente}
                          onChange={(e) => AlterarNota({ notaX: item.calibrarNineBox?.notas.notaX ?? 0, notaY: isNaN(parseFloat(e)) ? 0 : parseFloat(e) }, item.id)}
                          value={item.calibrarNineBox.notas.notaY} width={'7.9rem'}
                          min={0}
                          max={200}
                          step={0.1}
                          h={'1.75rem'}
                          size={'sm'}
                          isDisabled={item.status === 1 || Model?.dashboard.concluido}
                          borderRadius={'.25rem'}
                        >
                          <NumberInputField />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </Flex>
                      <Flex flexDirection={'column'}>
                        <Box mb={'.15rem'} fontSize={'.875rem'} fontWeight={'700'}>
                          {item.calibrarNineBox.nineBox.configuracaoEixoX.titulo}
                        </Box>
                        <NumberInput
                          isInvalid={item.calibrarNineBox.notaXInconentente}
                          onChange={(e) => AlterarNota({ notaY: item.calibrarNineBox?.notas.notaY ?? 0, notaX: isNaN(parseFloat(e)) ? 0 : parseFloat(e) }, item.id)}
                          width={'7.9rem'}
                          value={item.calibrarNineBox.notas.notaX}
                          step={0.1}
                          min={0}
                          max={200}
                          h={'1.75rem'}
                          isDisabled={item.status === 1 || Model?.dashboard.concluido}
                          size={'sm'}
                          borderRadius={'.25rem'}
                        >
                          <NumberInputField />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </Flex>
                      {PodeRestaurarSugestao(item) && <Flex flexDirection={'column'} justifyContent={'end'}>
                        <ElementoTooltipCmp label={`A pesquisa de desempenho indica ${item.calibrarNineBox.notaDesempenhoSugerida?.toFixed(1) ?? ''} para este eixo`}>
                          <ButtonCmp
                            VarColor='Green2'
                            small
                            leftIcon={<FaUndo />}
                            onClick={() => RestaurarNotaSugerida(item)}
                          >Usar a nota da pesquisa</ButtonCmp>
                        </ElementoTooltipCmp>
                      </Flex>}
                  </Flex>
                  <NineBoxCalibrar
                    quadranteSelecionado={item.calibrarNineBox.nomeQuadrante}
                    selecionarQuadrante={(quadId) => SelecionarQuadrante(item.id, quadId)}
                    model={item.calibrarNineBox.nineBox}
                    variant='avaliar'
                    isDisabled={item.status === 1 || Model?.dashboard.concluido}
                  />
                  <FormControl>
                    <Text fontWeight={'700'} fontSize={'.875rem'} mb={'.25rem'}>Deixe um comentário para registro da calibração</Text>
                    <Textarea
                      color={'var(--Gray2)'}
                      placeholder='Deixe seu comentário'
                      height={'8.25rem'}
                      isDisabled={item.status === 1 || Model?.dashboard.concluido}
                      borderColor='var(--Gray4)'
                      onChange={(e) => OnChangeComentario(item.id, e.target.value)}
                    />
                  </FormControl>
                  {!Model?.dashboard.concluido && <Flex justifyContent={'center'} mt={'1rem'}>
                    <ButtonCmp isDisabled={item.status === 1} onClick={() => OnSendCalibracaoNineBox(item.id, item.calibrarNineBox)} VarColor='Green2'>Enviar calibração</ButtonCmp>
                  </Flex>}
                </Flex>
              </Flex>
            </Flex>
          }
          return <Flex fontWeight={700} fontSize={'18px'}>Houve um erro ao puxar os dados do 9Box desse colaborador, por favor contate o suporte do SAH</Flex>

        case 14:
          if (!item.infosPDI?.iniciado) {
            return (<Flex>
              <ImgSah center textoPersonalizado={'O item ainda não foi iniciado' + (IsGestorOrADM() ? ', clique no botão abaixo para começar agora o processo de preenchimento do PDI para o colaborador' : ', aguarde a seleção de itens a trabalhar para realizar o preenchimento do PDI')}>
                {IsGestorOrADM() && <ButtonCmp VarColor='Green2' big onClick={() => AdiantarItem(item.id)}>Iniciar item agora</ButtonCmp>}
              </ImgSah>
            </Flex>)
          } else if (IsGestorOrADM() && item.acoesParaAprovar) {
            return (<Flex flexDir={'column'} w='100%'>
              <h3>Ações para aprovar</h3>
              <Flex marginTop={'1rem'} flexDir={'column'} gap='1rem'>
                {item.acoesParaAprovar.filter(e => e.status === 1).length > 0
                  ? item.acoesParaAprovar.filter(e => e.status === 1).map((e, i) => {
                    return (
                    <Acao
                      key={i}
                      onRemove={(acaoId) => onOpenModalDeleteAcao(item.pdi?.id ?? '', acaoId)}
                      onUpdate={(acao) => AtualizarAcaoAprovar(item.id, acao, item.acoesParaAprovar)}
                      acao={e}
                    />
                    )
                  })
                  : <Text fontWeight={700} fontSize={'.875rem'} color={'var(--Azul)'}>Nenhuma ação pendente para aprovar!</Text>}
                <Flex gap={'.5rem'}>
                  <ButtonCmp
                    disabled={item.acoesParaAprovar.filter(e => e.status === 1).length === 0}
                    VarColor='Green2' onClick={() => AprovarPDI(item.id, item.pdi?.id ?? '', item.acoesParaAprovar ?? [])}
                  >Aprovar PDI</ButtonCmp>
                  <ButtonCmp
                    onClick={() => SolicitarAjustes(item.id, item.pdi?.id ?? '', item.acoesParaAprovar ?? [])}
                    isDisabled={item.acoesParaAprovar.filter(e => e.status === 1).length === 0}
                    VarColor='Rosa'
                  >Solicitar ajustes</ButtonCmp>
                </Flex>
                {item.acoesParaAprovar.filter(e => e.status !== 1).length > 0 && <Flex flexDir={'column'} mt={'.75rem'}>
                  <h3>Outras ações:</h3>
                  <Flex gap={'1rem'} mt={'1rem'} flexWrap={'wrap'}>
                    {item.acoesParaAprovar.filter(e => e.status !== 1).map((e, i) => {
                      return (
                        <CardAcao
                          key={i}
                          acao={e}
                        />
                      )
                    })}
                  </Flex>
                </Flex>}
              </Flex>
            </Flex>)
          } else if (item.itensATrabalhar?.podeEditar && ((!item.itensATrabalhar.competencias || item.itensATrabalhar.competencias.length === 0) || SelecionarNovamente.some(e => e === item.id))) {
            return (
              <Flex flexDir={'column'} gap={'1rem'} w={'100%'}>
                <Flex flexDir={'column'}>
                  <Flex justifyContent={'space-between'} alignItems={'center'}>
                    <h3>Seleção de itens a trabalhar</h3>
                    {SelecionarNovamente.some(e => e === item.id) && <ButtonCmp VarColor='c6' onClick={() => setSelecionarNovamente([])}>Cancelar alterações</ButtonCmp>}
                  </Flex>
                  {item.itensATrabalhar.dataUltimaSelecao ? <Text>Data da última seleção: <strong>{item.itensATrabalhar.dataUltimaSelecao}</strong></Text> : <Text fontSize={'14px'} color={'var(--Gray2)'}>Data de início: {item.itensATrabalhar.dataInicio} - Prazo para preenchimento: {item.itensATrabalhar.dataFim}</Text>}
                </Flex>
                {item.itensATrabalhar.competencias?.length > 0 && <Flex flexDirection={'column'} gap={'1rem'}>
                  <Divider borderColor={'var(--c6)'} opacity={'.8'} mb={'.325rem'}/>
                  <Text fontSize={'16px'} fontWeight={'600'}>Última seleção realizada</Text>
                  <Grid gridTemplateColumns={'repeat(3, 1fr)'} gap={'1.5rem'}>
                    {item.itensATrabalhar.competencias?.map((e, i) => {
                      return (
                        <ItemATrabalhar pos={i + 1} recomendacao={e}/>
                      )
                    })}
                  </Grid>
                  <Divider borderColor={'var(--c6)'} opacity={'.8'} mb={'1.25rem'} mt={'1rem'}/>
                </Flex>}
                <TabelaItensAMelhorar model={item.itensATrabalhar} OnCheck={(val, comp) => OnCheckItensATrabalhar(val, comp, item.id)}/>
                <Flex justifyContent={'center'} gap={'1rem'}>
                  {SelecionarNovamente.some(e => e === item.id) && <ButtonCmp VarColor='c6' onClick={() => setSelecionarNovamente([])}>Cancelar alterações</ButtonCmp>}
                  <ButtonCmp VarColor='Green2' isDisabled={item.itensATrabalhar?.selecionadas.length === 0} onClick={() => OnSelectItens(item.itensATrabalhar?.selecionadas ?? [], item.id, item.itensATrabalhar?.competencias.length)} leftIcon={<FaSave />}>Salvar alterações</ButtonCmp>
                </Flex>
              </Flex>
            )
          } else if (item.itensATrabalhar && item.itensATrabalhar.competencias.length > 0 && item.pdi) {
            if ((!item.itensATrabalhar.recomendacoes || item.itensATrabalhar.recomendacoes.length === 0) && ItemIdGerarRecomendacoes === undefined) {
              setItemIdGerarRecomendacoes(item.id)
            }
            return (
              <Flex flexDir={'column'} width={'full'}>
                <Flex flexDir={'column'} mb={'1.5rem'}>
                  <h3>PDI</h3>
                  <Text fontSize={'14px'} color={'var(--Gray2)'}>Data de início: {item.infosPDI?.dataInicio} - Prazo para preenchimento: {item.infosPDI?.dataFim}</Text>
                </Flex>
                {item.itensATrabalhar?.competencias?.length > 0 && <Flex flexDirection={'column'} gap={'1rem'}>
                  <Divider borderColor={'var(--c6)'} opacity={'.8'} mb={'.325rem'}/>
                  <Flex justifyContent={'space-between'} alignItems={'center'} mb={'1rem'}>
                    <Text fontSize={'16px'} fontWeight={'600'}>Última seleção realizada</Text>
                    {!Model?.dashboard.concluido && item.itensATrabalhar?.podeEditar && <ButtonCmp VarColor='Green2' onClick={() => setSelecionarNovamente([...SelecionarNovamente, item.id])} isLoading={IsLoadingRecomendacoes}>Alterar seleção</ButtonCmp>}
                  </Flex>
                  <Grid gridTemplateColumns={'repeat(3, 1fr)'} gap={'1.5rem'}>
                    {item.itensATrabalhar?.competencias?.map((e, i) => {
                      return (
                        <ItemATrabalhar pos={i + 1} recomendacao={e}/>
                      )
                    })}
                  </Grid>
                  <Divider borderColor={'var(--c6)'} opacity={'.8'} mb={'1.25rem'} mt={'1rem'}/>
                </Flex>}
                <Tabs variant='unstyled'>
                  <TabList >
                    <Tab backgroundColor={'white'} color={'var(--c6)'} border='1px solid var(--c6)' borderRadius={'.25rem 0 0 0'} _selected={{ color: 'var(--Azul)', borderColor: 'var(--Azul)' }}>Plano de desenvolvimento</Tab>
                    <Tab backgroundColor={'white'} color={'var(--c6)'} border='1px solid var(--c6)' borderRadius={'0 .25rem 0 0'} _selected={{ color: 'var(--Azul)', borderColor: 'var(--Azul)' }}>
                    {(item.itensATrabalhar.recomendacoes && !IsLoadingRecomendacoes)
                      ? 'Recomendações'
                      : <Flex alignItems={'center'} gap={'1rem'}>
                        Carregando recomendações
                        <Spinner size={'sm'}/>
                      </Flex>
                    }
                    </Tab>
                  </TabList>
                  <TabPanels background={'white'} border={'1px solid var(--c6)'} borderBottomLeftRadius='.25rem' borderBottomRightRadius='.25rem'>
                  <TabPanel>
                    {!item.infosPDI.podeEditar && <ImgSah center textoPersonalizado={'Aguarde para que o ' + (parseJwt().cid === Model?.participante.id ? 'colaborador' : 'responsável') + ' suba a primeira versão do plano de desenvolvimento'}></ImgSah>}
                    {item.infosPDI.podeEditar && <Flex justifyContent={'space-between'} alignItems={'self-start'} mb={'.5rem'}>
                      <Flex flexDir={'column'}>
                        <Subtitulo>Descreva ações práticas que você irá realizar para trabalhar neste PDI</Subtitulo>
                        <Text fontSize={'14px'} fontWeight={'400'} color={'var(--c7)'}>Os campos destacados e com * são de preenchimento obrigatório</Text>
                      </Flex>
                      {!Model?.dashboard.concluido && <Flex gap={'.5rem'}>
                        <ButtonCmp isDisabled={!item.pdi.canEdit} onClick={() => AdicionarAcao(item.pdi?.acoes ?? [], item.id)} leftIcon={<FaPlus />} VarColor='Green2'>Adicionar outra ação</ButtonCmp>
                        <Flex flexDir={'column'} gap={'.5rem'}>
                          <ButtonCmp isDisabled={!item.pdi.canEdit} onClick={() => setModalAcoesIsOpen(true)} VarColor='Roxo'>Buscar ações de PDIs anteriores</ButtonCmp>
                          {item.itensATrabalhar.competencias.length > 0 && <ButtonCmp isDisabled={!item.pdi.canEdit || !item.itensATrabalhar.recomendacoes || item.itensATrabalhar.recomendacoes?.length === 0} onClick={() => GerarAcoesPorRecomendacoes(item)} VarColor='Rosa' isLoading={IsLoadingRecomendacoes}>Gerar ações com base nas recomendações</ButtonCmp>}
                        </Flex>
                      </Flex>}
                    </Flex>}
                    {item.infosPDI.podeEditar && <Flex marginTop={'1rem'} flexDir={'column'} gap={'1rem'}>
                      {
                        item.pdi?.acoes.map((e, i) => {
                          return (
                            <AcaoPDI
                              key={i}
                              onChangeProgresso={OnChangeProgressos}
                              onUpdate={(acao) => { AtualizarAcao(item.id, acao, item.pdi) }}
                              onRemove={(idAcao) => onOpenModalDelete(idAcao, item.id)}
                              avaliacoes={item.pdi?.avaliacoes ?? []}
                              acao={e}
                              canEdit={item.pdi?.canEdit === true}
                              competencias={Competencias}
                              meuPDI={parseJwt().cid === Model?.participante.id}
                              position={i}
                              onRemoveProgresso={(acaoId) => setProgressos(Progressos.filter(e => e.acaoId !== acaoId))}
                              OnReload={() => onGetItemById(item.id)}
                            />
                          )
                        })
                      }
                      {item.pdi?.acoes.length === 0 && <Flex py={'1.5rem'} justifyContent='center' fontWeight={600}>Adicione uma ação para poder editá-la</Flex>}
                    </Flex>}
                    <Flex gap={'1rem'} justifyContent='center' mt={'1.5rem'}>
                      {item.infosPDI.podeEditar && !Model?.dashboard.concluido && item.pdi.acoes.length > 0 && (
                        <ElementoTooltipCmp label={item.pdi.jaFoiAprovado ? 'PDI já aprovado, as alterações precisam passar por aprovação' : ''}>
                          <ButtonCmp
                            VarColor={'Rosa'}
                            isDisabled={item.pdi.jaFoiAprovado}
                            onClick={() => { ActionClick(true, item.id, item.pdi) }}
                          >Salvar rascunho</ButtonCmp>
                        </ElementoTooltipCmp>
                      )}

                      {item.infosPDI.podeEditar && !Model?.dashboard.concluido && item.pdi.acoes.length > 0 && (
                        <ElementoTooltipCmp label={item.pdi.acoes.some(e => e.status === 2) && Model?.participante?.id !== parseJwt().cid ? 'Aguardando as alterações do colaborador!' : ''}>
                          <ButtonCmp
                            onClick={() => { ActionClick(false, item.id, item.pdi) }}
                            isDisabled={item.pdi.acoes.some(e => e.status === 2) && Model?.participante?.id !== parseJwt().cid}
                            VarColor='Green2'
                          >{ObterTituloBtn(item.pdi)}</ButtonCmp>
                        </ElementoTooltipCmp>
                      )}
                    </Flex>
                  </TabPanel>
                    {(item.itensATrabalhar.recomendacoes && !IsLoadingRecomendacoes) && <TabPanel px={'2rem'}>
                      <TabRecomendacao recomendacoes={item.itensATrabalhar.recomendacoes} onGerarRecomendacoes={() => setModalIAIsOpen(item)} acaoEdit={AcaoEdit} GerarAcoesPorRecomendacoes={GerarAcoesPorRecomendacoes} item={item} onRefresh={(compId) => onRefreshCompetencia(item.id, compId)} onSalvar={(competencia) => onSaveCompetencia(item.id, competencia)} isLoadingAcao={IsLoadingAcao}/>
                    </TabPanel>}
                    {(!item.itensATrabalhar.recomendacoes || IsLoadingRecomendacoes) && <TabPanel px={'2rem'}>
                      <Flex alignItems={'center'} color={'var(--Azul)'} fontSize={'18px'} fontWeight={600} justifyContent={'center'} gap={'.75rem'} py={'3rem'}>
                        Carregando recomendações... <Spinner size={'md'} colorScheme={'blue'}/>
                      </Flex>
                    </TabPanel>}
                  </TabPanels>
                </Tabs>
              </Flex>)
          }

          return <ImgSah center textoPersonalizado={item.erroPersonalizado ?? 'O processo de preenchimento do PDI ainda não foi iniciado, aguarde as etapas anteriores para seguir com esse item'}>
        </ImgSah>
      }
    } else {
      return <h3>Item não encontrado</h3>
    }
  }

  function ObterRecomendacaoPorIA(competenciasId: string[], itemId: string, loading?: boolean, itemNovo?: iItemDashResponse): void {
    if (!Model) return

    const propriedade = FaseAtual === 0 ? 'entrada' : 'desenvolvimento'
    const indexItem = Model[propriedade].findIndex(e => e.id === itemId)
    const item = itemNovo ?? Model[propriedade][indexItem]
    if (!item.itensATrabalhar) return

    if (loading) setIsLoadingRecomendacoes(true)
    appApi.post(`FeedbackPersonalizado/${id}/IA/${itemId}/Acoes`, { Ids: competenciasId })
      .then(res => {
        if (res.status === 200 && item.itensATrabalhar) {
          const acoes: iAcaoRecomendacao[] = res.data
          setModel({
            ...Model,
            [propriedade]: UpdateElementByPosition(Model[propriedade], indexItem, { ...item, itensATrabalhar: { ...item.itensATrabalhar, recomendacoes: acoes } })
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setModalIAIsOpen(undefined)
        setIsLoadingRecomendacoes(false)
        setItemIdGerarRecomendacoes(undefined)
        toast({
          title: 'Recomendações geradas com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top'
        })
      })
  }

  useEffect(() => {
    getDashboard(true)
    ObterCompetencias()
  }, [])

  useEffect(() => {
    setIsLoadingIndividual(true)
    setTimeout(() => {
      setIsLoadingIndividual(false)
    }, 300)
  }, [TabGrafico])

  useEffect(() => {
    const handleResize = (): void => setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (ItemIdGerarRecomendacoes) {
      const item = Model?.desenvolvimento.find(e => e.id === ItemIdGerarRecomendacoes)
      if (item?.itensATrabalhar) {
        ObterRecomendacaoPorIA(item.itensATrabalhar?.competencias.map(e => e.competenciaId ?? '') ?? [], ItemIdGerarRecomendacoes)
      }
    }
  }, [ItemIdGerarRecomendacoes])

  useEffect(() => {
    if (ItemAtual === '' && Model) {
      getDashboard()
    } else if (ItemAtual) {
      const calibracao = Model?.desenvolvimento.find(e => e.id === ItemAtual && e.tipo === 13)
      if (calibracao?.avaliacaoCalibracaoId && calibracao.calibracaoDisponivel && parseJwt().cid !== Model?.participante.id) {
        OnRealizarCalibracao(calibracao, Model?.desenvolvimento?.findIndex(e => e.id === ItemAtual && e.tipo === 13) ?? 0)
      } else {
        setCalibracaoEmAndamento([])
        onGetItemById(ItemAtual)
      }
    }
  }, [ItemAtual])

  return (
    <LoadingContainer loading={!Model} linhas={25} my='2.5rem' px='3rem'>
      <ModalDelete
        isOpen={ModalAcaoIsOpen}
        message={'Deseja realmente excluir esta ação?'}
        onRequestClose={onCloseModalDeleteAcao}
        onConfirm={() => Exluir(PDIAprovarId ?? '', ItemAtual ?? '', AcaoAprovarId ?? '')}
        center
      />
      <ModalDelete
        isOpen={ModalDeleteAcaoIsOpen}
        message='Deseja realmente excluir esta ação?'
        onRequestClose={onCloseModalDelete}
        center
        onConfirm={() => RemoverAcao(AcaoId?.id ?? '', AcaoId?.itemId ?? '')}
      />
      {ModalIAIsOpen && <ModalDelete
        isOpen
        onRequestClose={() => setModalIAIsOpen(undefined)}
        onConfirm={() => ObterRecomendacaoPorIA(ModalIAIsOpen.itensATrabalhar?.competencias.map(e => e.competenciaId ?? '') ?? [], ModalIAIsOpen.id, true)}
        center
        message={'Deseja gerar novamente suas recomendações? As atuais serão substituídas pelas novas que serão geradas'}
      />}
      {ModalAcoesIsOpen && <ModalAcoesRemanejo
        id={id ?? ''}
        isOpen={ModalAcoesIsOpen}
        onConfirm={(pdis) => {
          toast({
            title: 'Ações remanejadas com sucesso!',
            duration: 4000,
            position: 'top',
            status: 'success'
          })
          setModalAcoesIsOpen(false)
          OnPutAcaoRemanejada(pdis, ItemAtual ?? '')
        }}
        onRequestClose={() => setModalAcoesIsOpen(false)}
        participanteId={Model?.participante.id ?? ''}
        pdiId={GetPDIId()}
      />}
      <Flex minWidth={'95vw'} maxW={'95vw'} flexDir={'column'} mx={'auto'} mt={'1.5rem'} >
        {ModalAddParticipanteIsOpen && (
          <ModalAddParticipante
            isOpen={ModalAddParticipanteIsOpen}
            onConfirm={CreateAvaliador}
            onRequestClose={onCloseModalAddParticipante}
            iniciada={true}
            avaliador={Temp?.avaliador}
            avaliacaoId={Temp?.avaliacaoId}
            onDeleteAvaliador={(avalId, avaliador) => { onOpenModalDeleteAvaliador(avalId, avaliador, Temp?.itemId ?? '') }}
            onReenviarAvaliador={ReenviarConviteAvaliador}
            onUpdateAvaliador={UpdateAvaliador}
          />
        )}
        {DataFimUpdate && <ModalReabrir
          isOpen={true}
          onConfirm={onUpdateDataFimItem}
          onRequestClose={() => setDataFimUpdate(undefined)}
          dataMinima={DataFimUpdate.dataFim}
        />}
        <ModalDelete
          isOpen={ModalDeleteIsOpen}
          onRequestClose={onRequestModalDeleteClose}
          onConfirm={DeleteAvaliador}
          center
          message={'Deseja realmente excluir este avaliador?'}
        />
        {EncerrarAval && <ModalDelete
          isOpen={ModalEncerrarIsOpen}
          onRequestClose={onRequestModalEncerrarClose}
          onConfirm={EncerrarAvaliacao}
          center
          message={'Tem certeza que deseja encerrar esta avaliação?'}
        />}
        <Flex justifyContent={'space-between'} mb={'1rem'} gap={'.75rem'} alignItems={'center'}>
          <h1>{Model?.nome}</h1>
          <ButtonCmp VarColor='c6' onClick={() => nav(-1)}>Voltar</ButtonCmp>
        </Flex>

        {Model && <Flex maxW={'95vw'} minW={'95vw'} justifyContent={'center'} h={'full'}>
          <SidebarFeedback fase={FaseAtual} onSelectItem={(id, fase) => { setItemAtual(id); setFaseAtual(fase) }} itemAtual={ItemAtual ?? ''} isLoading={IsLoading || IsLoadingItem} itensOpacosIds={ItensOpacosIds} model={Model} onChangeIsExpanded={(e) => setIsExpanded(e)}/>
          <Flex bg={'var(--c1)'} borderRadius={'0 .25rem .25rem 0'} p={'1rem'} minH={'full'} style={{ width: `calc(100% - ${IsExpanded ? 310 : 24}px)` }} pl={!IsExpanded ? '3rem' : ''}>
            <LoadingContainer linhas={16} loading={IsLoading || IsLoadingItem} my='1.5rem'>
              {GetItemAtual()}
            </LoadingContainer>
          </Flex>
        </Flex>
      }
      </Flex>
      <Flex mt={'1.5rem'}></Flex>
    </LoadingContainer>
  )
}
